import type { Dict } from "./types";

export const kn: Dict = {
  common: {
    save: "ಬದಲಾವಣೆಗಳನ್ನು ಉಳಿಸಿ",
    saving: "ಉಳಿಸಲಾಗುತ್ತಿದೆ…",
    cancel: "ರದ್ದುಮಾಡಿ",
    remove: "ತೆಗೆದುಹಾಕಿ",
    continue: "ಮುಂದುವರಿಸಿ",
    somethingWrong: "ಏನೋ ತಪ್ಪಾಗಿದೆ",
    logOut: "ಲಾಗ್ ಔಟ್",
    welcomeBackGreet: "ಮತ್ತೆ ಸ್ವಾಗತ,",
    hiGreet: "ಹಾಯ್,",
    statusOpen: "ಓಪನ್",
    statusInProgress: "ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    statusResolved: "ಪರಿಹಾರವಾಗಿದೆ",
  },
  requests: {
    categoryLabel: "ವರ್ಗ (ಐಚ್ಛಿಕ)",
    categoryPlumbing: "ಪ್ಲಂಬಿಂಗ್",
    categoryElectrical: "ಎಲೆಕ್ಟ್ರಿಕಲ್",
    categoryAppliance: "ಉಪಕರಣ",
    categoryFurniture: "ಪೀಠೋಪಕರಣ",
    categoryCleaning: "ಶುಚಿಗೊಳಿಸುವಿಕೆ",
    categoryPestControl: "ಪೆಸ್ಟ್ ಕಂಟ್ರೋಲ್",
    categoryOther: "ಇತರೆ",
    urgentCheckboxLabel: "ಇದು ತುರ್ತು",
    urgentBadge: "ತುರ್ತು",
    photoLabel: "ಫೋಟೋ ಸೇರಿಸಿ (ಐಚ್ಛಿಕ)",
    addPhotoBtn: "ಫೋಟೋ ಸೇರಿಸಿ",
    removePhotoAria: "ಫೋಟೋ ತೆಗೆದುಹಾಕಿ",
    updatesHeading: "ಅಪ್‌ಡೇಟ್‌ಗಳು",
    noUpdatesYet: "ಇನ್ನೂ ಯಾವುದೇ ಅಪ್‌ಡೇಟ್ ಇಲ್ಲ.",
    addCommentPlaceholder: "ಒಂದು ಟಿಪ್ಪಣಿ ಸೇರಿಸಿ…",
    postCommentBtn: "ಪೋಸ್ಟ್ ಮಾಡಿ",
    postingCommentBtn: "ಪೋಸ್ಟ್ ಆಗುತ್ತಿದೆ…",
    callBtn: "ಕರೆ ಮಾಡಿ",
    whatsappBtn: "ವಾಟ್ಸಾಪ್",
  },
  nav: {
    home: "ಹೋಮ್",
    listings: "ಲಿಸ್ಟಿಂಗ್‌ಗಳು",
    notebook: "ನೋಟ್‌ಬುಕ್",
    requests: "ರಿಕ್ವೆಸ್ಟ್‌ಗಳು",
    settings: "ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
    browse: "ಪ್ರಾಪರ್ಟಿಗಳನ್ನು ನೋಡಿ",
    payments: "ಪೇಮೆಂಟ್ಸ್",
    ownerDashboard: "ಓನರ್ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    tenantDashboard: "ಟೆನೆಂಟ್ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
  },
  auth: {
    welcomeEyebrow: "ಸ್ವಾಗತ",
    welcomeTitle: "ToLetBook ಗೆ ಸ್ವಾಗತ",
    welcomeSub: "ನಿಮ್ಮ ಖಾತೆಗೆ ಲಾಗ್ ಇನ್ ಮಾಡಿ, ಅಥವಾ ಹೊಸ ಖಾತೆ ರಚಿಸಿ.",
    logIn: "ಲಾಗ್ ಇನ್ ಮಾಡಿ",
    createAccount: "ಖಾತೆ ರಚಿಸಿ",
    loginTitle: "ಮತ್ತೆ ಸ್ವಾಗತ",
    loginSub: "ನಿಮ್ಮ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ಗೆ ಮುಂದುವರಿಯಲು ಲಾಗ್ ಇನ್ ಮಾಡಿ.",
    registerTitle: "ನಿಮ್ಮ ಖಾತೆಯನ್ನು ರಚಿಸಿ",
    registerSub: "ಆಸ್ತಿಯನ್ನು ಪಟ್ಟಿ ಮಾಡಿ ಅಥವಾ ನಿಮ್ಮ ಮುಂದಿನ ಮನೆಯನ್ನು ಹುಡುಕಿ — ಬ್ರೋಕರ್‌ಗಳಿಲ್ಲದೆ, ತೊಂದರೆಯಿಲ್ಲದೆ.",
    passwordHint: "ಕನಿಷ್ಠ 6 ಅಕ್ಷರಗಳು.",
    referralCodeLabel: "ರೆಫರಲ್ ಕೋಡ್ (ಐಚ್ಛಿಕ)",
    referralCodePlaceholder: "ನಿಮ್ಮ ಬಳಿ ಕೋಡ್ ಇದ್ದರೆ ನಮೂದಿಸಿ",
    agreeTermsText: "ನಾನು ToLetBook ನ ನಿಯಮಗಳು & ಷರತ್ತುಗಳು ಮತ್ತು ಗೌಪ್ಯತಾ ನೀತಿಗೆ ಒಪ್ಪುತ್ತೇನೆ",
    viewTermsLink: "ನಿಯಮಗಳು & ಷರತ್ತುಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
    viewPrivacyLink: "ಗೌಪ್ಯತಾ ನೀತಿಯನ್ನು ವೀಕ್ಷಿಸಿ",
    hideTermsLink: "ನಿಯಮಗಳು & ಷರತ್ತುಗಳನ್ನು ಮರೆಮಾಡಿ",
    errMustAgreeTerms: "ಮುಂದುವರಿಯಲು ದಯವಿಟ್ಟು ನಿಯಮಗಳು & ಷರತ್ತುಗಳನ್ನು ಒಪ್ಪಿಕೊಳ್ಳಿ",
    loginBusy: "ಲಾಗ್ ಇನ್ ಆಗುತ್ತಿದೆ…",
    emailLabel: "ಇಮೇಲ್",
    emailPlaceholder: "you@example.com",
    passwordLabel: "ಪಾಸ್‌ವರ್ಡ್",
    passwordPlaceholder: "ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್",
    errEmailPassword: "ನಿಮ್ಮ ಇಮೇಲ್ ಮತ್ತು ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ",
    getStartedEyebrow: "ಶುರು ಮಾಡೋಣ",
    roleTitle: "ನೀವು ಯಾರು ಎಂದು ತಿಳಿಸಿ",
    roleSub: "ಇದರಿಂದ ನಿಮಗೆ ಸರಿಯಾದ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ಸಿದ್ಧಪಡಿಸಬಹುದು.",
    roleOwnerTitle: "ನಾನು ಪ್ರಾಪರ್ಟಿ / ಪಿಜಿ ಓನರ್",
    roleOwnerSub: "ಪ್ರಾಪರ್ಟಿ ಲಿಸ್ಟ್ ಮಾಡಿ, ಟೆನೆಂಟ್‌ಗಳನ್ನು ನಿರ್ವಹಿಸಿ, ಬಾಡಿಗೆ ಟ್ರ್ಯಾಕ್ ಮಾಡಿ",
    roleTenantTitle: "ನಾನು ಒಬ್ಬ ಟೆನೆಂಟ್",
    roleTenantSub: "ಲಿಸ್ಟಿಂಗ್‌ಗಳನ್ನು ನೋಡಿ, ಬಾಡಿಗೆ ಪಾವತಿಸಿ, ರಿಕ್ವೆಸ್ಟ್ ಕಳುಹಿಸಿ",
    step1Eyebrow: "ಹಂತ 1",
    credentialsTitle: "ನಿಮ್ಮ ಲಾಗಿನ್ ರಚಿಸಿ",
    newPasswordPlaceholder: "ಕನಿಷ್ಠ 6 ಅಕ್ಷರಗಳು",
    phoneOptionalLabel: "ಮೊಬೈಲ್ ನಂಬರ್ (ಐಚ್ಛಿಕ)",
    phonePlaceholder: "10 ಅಂಕಿಗಳ ಮೊಬೈಲ್ ನಂಬರ್",
    errValidEmail: "ಸರಿಯಾದ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
    errPasswordLength: "ಪಾಸ್‌ವರ್ಡ್ ಕನಿಷ್ಠ 6 ಅಕ್ಷರಗಳಿರಬೇಕು",
    errValidPhoneOptional: "ಸರಿಯಾದ 10 ಅಂಕಿಗಳ ಮೊಬೈಲ್ ನಂಬರ್ ನಮೂದಿಸಿ, ಅಥವಾ ಖಾಲಿ ಬಿಡಿ",
    step2Eyebrow: "ಹಂತ 2",
    profileTitle: "ನಿಮ್ಮ ಬಗ್ಗೆ ಸ್ವಲ್ಪ ತಿಳಿಸಿ",
    fullNameLabel: "ಪೂರ್ಣ ಹೆಸರು",
    fullNamePlaceholder: "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರು",
    profileBusy: "ದಯವಿಟ್ಟು ಕಾಯಿರಿ…",
    errName: "ನಿಮ್ಮ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    step3Eyebrow: "ಹಂತ 3",
    propertyTypeTitle: "ನೀವು ಏನನ್ನು ನಿರ್ವಹಿಸುತ್ತೀರಿ?",
    propertyTypeSub: "ಇದರಿಂದ ನಿಮಗೆ ಯಾವ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ವ್ಯೂಗಳು ಕಾಣಿಸುತ್ತವೆ ಎಂದು ನಿರ್ಧಾರವಾಗುತ್ತದೆ — ಇದನ್ನು ನಂತರ ಬದಲಾಯಿಸಬಹುದು.",
    typeIndependentTitle: "ಇಂಡಿಪೆಂಡೆಂಟ್ ಪ್ರಾಪರ್ಟಿಗಳು",
    typeIndependentSub: "ಪೂರ್ಣ ಮನೆಗಳು, ಫ್ಲ್ಯಾಟ್‌ಗಳು, ವಿಲ್ಲಾಗಳು",
    typePgTitle: "ಪಿಜಿ / ಹಾಸ್ಟೆಲ್",
    typePgSub: "ಬೆಡ್ ಪ್ರಕಾರ ಬಾಡಿಗೆ ಇರುವ ಶೇರ್ಡ್ ರೂಮ್‌ಗಳು",
    typeBothTitle: "ಎರಡೂ",
    typeBothSub: "ಇಂಡಿಪೆಂಡೆಂಟ್ ಯೂನಿಟ್‌ಗಳು ಮತ್ತು ಪಿಜಿ ರೂಮ್‌ಗಳ ಮಿಶ್ರಣ",
    almostDoneEyebrow: "ಬಹುತೇಕ ಮುಗಿಯಿತು",
    cityTitle: "ನೀವು ಎಲ್ಲಿ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತೀರಿ?",
    citySub: "ಇದರ ಆಧಾರದ ಮೇಲೆ ನಿಮ್ಮ ಲಿಸ್ಟಿಂಗ್‌ಗಳನ್ನು ಹತ್ತಿರದ ಬಾಡಿಗೆದಾರರಿಗೆ ಮೊದಲು ತೋರಿಸುತ್ತೇವೆ.",
    cityLabel: "ನಗರ",
    cityPlaceholder: "ಉದಾ. ಮುಂಬೈ",
    bankDetailsTitle: "ನಾವು ನಿಮಗೆ ಹೇಗೆ ಪಾವತಿಸಬೇಕು?",
    bankDetailsSub: "ಬಾಡಿಗೆ ಮತ್ತು ಡಿಪಾಸಿಟ್ ಪಾವತಿಗಳನ್ನು ನೇರವಾಗಿ ನಿಮಗೆ ಕಳುಹಿಸಲು ನಿಮ್ಮ ಬ್ಯಾಂಕ್ ಖಾತೆಯನ್ನು ಸೇರಿಸಿ.",
    payoutMethodUpi: "UPI ಐಡಿ",
    payoutMethodBank: "ಬ್ಯಾಂಕ್ ಖಾತೆ",
    upiIdLabel: "UPI ಐಡಿ",
    upiIdPlaceholder: "ಉದಾ. name@okhdfcbank",
    errValidUpi: "ಸರಿಯಾದ UPI ಐಡಿ ನಮೂದಿಸಿ",
    bankAccountHolderLabel: "ಖಾತೆದಾರರ ಹೆಸರು",
    bankAccountHolderPlaceholder: "ಬ್ಯಾಂಕ್ ದಾಖಲೆಗಳ ಪ್ರಕಾರ",
    bankAccountNumberLabel: "ಖಾತೆ ಸಂಖ್ಯೆ",
    bankAccountNumberPlaceholder: "ಬ್ಯಾಂಕ್ ಖಾತೆ ಸಂಖ್ಯೆ",
    bankIfscLabel: "IFSC ಕೋಡ್",
    bankIfscPlaceholder: "ಉದಾ. HDFC0001234",
    bankDetailsHint: "ನೀವು ಇದನ್ನು ಯಾವಾಗ ಬೇಕಾದರೂ ಸೆಟ್ಟಿಂಗ್‌ಗಳಿಂದ ಸೇರಿಸಬಹುದು ಅಥವಾ ಬದಲಾಯಿಸಬಹುದು.",
    skipForNowLink: "ಈಗ ಬಿಟ್ಟುಬಿಡಿ",
    errValidIfsc: "ಸರಿಯಾದ IFSC ಕೋಡ್ ನಮೂದಿಸಿ",
    finishBusy: "ಸಿದ್ಧಪಡಿಸಲಾಗುತ್ತಿದೆ…",
    finish: "ಮುಗಿಸಿ",
    doneTitle: "ನೀವು ಸಿದ್ಧರಿದ್ದೀರಿ!",
    doneSub: "ನಿಮ್ಮ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ಸಿದ್ಧವಾಗಿದೆ.",
    goToDashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ಗೆ ಹೋಗಿ",
    welcomeBackToast: "ಮತ್ತೆ ಸ್ವಾಗತ, {name}!",
    welcomeNewToast: "ToLetBook ಗೆ ಸ್ವಾಗತ, {name}!",
    orDivider: "ಅಥವಾ",
    googleNoAccountToast: "ಆ Google ಇಮೇಲ್‌ಗೆ ToLetBook ಖಾತೆ ಕಂಡುಬಂದಿಲ್ಲ — ನಿಮ್ಮನ್ನು ಸೆಟಪ್ ಮಾಡೋಣ.",
    forgotPasswordLink: "ಪಾಸ್‌ವರ್ಡ್ ಮರೆತಿರಾ?",
    forgotPasswordEyebrow: "ಪಾಸ್‌ವರ್ಡ್ ರೀಸೆಟ್ ಮಾಡಿ",
    forgotPasswordTitle: "ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ಮರೆತಿರಾ?",
    forgotPasswordSub: "ನಿಮ್ಮ ಇಮೇಲ್ ನಮೂದಿಸಿ, ಅದನ್ನು ರೀಸೆಟ್ ಮಾಡಲು ನಾವು ನಿಮಗೆ ಒಂದು ಲಿಂಕ್ ಕಳುಹಿಸುತ್ತೇವೆ.",
    forgotPasswordSubmit: "ರೀಸೆಟ್ ಲಿಂಕ್ ಕಳುಹಿಸಿ",
    forgotPasswordBusy: "ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ…",
    forgotPasswordSentTitle: "ನಿಮ್ಮ ಇಮೇಲ್ ಪರಿಶೀಲಿಸಿ",
    forgotPasswordSentSub: "ಆ ಇಮೇಲ್‌ಗೆ ಖಾತೆ ಇದ್ದರೆ, ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ರೀಸೆಟ್ ಮಾಡಲು ನಾವು ಲಿಂಕ್ ಕಳುಹಿಸಿದ್ದೇವೆ.",
    resetPasswordEyebrow: "ಪಾಸ್‌ವರ್ಡ್ ರೀಸೆಟ್ ಮಾಡಿ",
    resetPasswordTitle: "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ಆಯ್ಕೆಮಾಡಿ",
    resetPasswordSub: "ಈ ಲಿಂಕ್ 1 ಗಂಟೆ ಮಾನ್ಯವಾಗಿರುತ್ತದೆ.",
    newPasswordLabel: "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್",
    confirmPasswordLabel: "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ದೃಢೀಕರಿಸಿ",
    errPasswordMismatch: "ಪಾಸ್‌ವರ್ಡ್‌ಗಳು ಹೊಂದಿಕೆಯಾಗುತ್ತಿಲ್ಲ",
    resetPasswordSubmit: "ಪಾಸ್‌ವರ್ಡ್ ರೀಸೆಟ್ ಮಾಡಿ",
    resetPasswordBusy: "ರೀಸೆಟ್ ಆಗುತ್ತಿದೆ…",
    resetPasswordDoneTitle: "ಪಾಸ್‌ವರ್ಡ್ ರೀಸೆಟ್ ಆಗಿದೆ",
    resetPasswordDoneSub: "ಈಗ ನೀವು ನಿಮ್ಮ ಹೊಸ ಪಾಸ್‌ವರ್ಡ್‌ನೊಂದಿಗೆ ಲಾಗ್ ಇನ್ ಮಾಡಬಹುದು.",
  },
  settings: {
    title: "ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
    profileMenu: "ಪ್ರೊಫೈಲ್",
    reportsMenu: "ರಿಪೋರ್ಟ್‌ಗಳು",
    plansMenu: "ಪ್ಲಾನ್‌ಗಳು ಮತ್ತು ಬಿಲ್ಲಿಂಗ್",
    referMenu: "ರೆಫರ್ ಮಾಡಿ ಗಳಿಸಿ",
    appearance: "ಥೀಮ್",
    language: "ಭಾಷೆ",
    dark: "ಡಾರ್ಕ್",
    light: "ಲೈಟ್",
    termsTitle: "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
    privacyTitle: "ಗೌಪ್ಯತಾ ನೀತಿ",
    bankDetailsMenu: "ನನ್ನ ಬ್ಯಾಂಕ್ ವಿವರಗಳು",
    bankDetailsHint: "ಬಾಡಿಗೆ ಮತ್ತು ಡಿಪಾಸಿಟ್ ಪಾವತಿಗಳನ್ನು ನೇರವಾಗಿ ನಿಮಗೆ ಕಳುಹಿಸಲು ಈ ವಿವರಗಳನ್ನು ಬಳಸಲಾಗುತ್ತದೆ. ಇವುಗಳನ್ನು ಬಾಡಿಗೆದಾರರಿಗೆ ಎಂದಿಗೂ ತೋರಿಸಲಾಗುವುದಿಲ್ಲ.",
    bankDetailsSaved: "ಬ್ಯಾಂಕ್ ವಿವರಗಳನ್ನು ಉಳಿಸಲಾಗಿದೆ",
    contactUsMenu: "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
    emailUsedToLogIn: "ಇಮೇಲ್ (ಲಾಗಿನ್‌ಗೆ ಬಳಸಲಾಗುತ್ತದೆ)",
    name: "ಹೆಸರು",
    phone: "ಫೋನ್ ನಂಬರ್",
    phonePlaceholder: "10 ಅಂಕಿಗಳ ಮೊಬೈಲ್ ನಂಬರ್",
    city: "ನಗರ",
    profileUpdated: "ಪ್ರೊಫೈಲ್ ಅಪ್‌ಡೇಟ್ ಆಗಿದೆ",
    demoNotice: "ಇಲ್ಲಿನ ಖಾತೆಗಳು ಡೆಮೊ ಉದ್ದೇಶಕ್ಕಾಗಿ ಮಾತ್ರ; ಯಾವುದಾದರೂ ಇಮೇಲ್ ಮತ್ತು ಪಾಸ್‌ವರ್ಡ್ ಬಳಸಿ.",
    verificationTitle: "ಗುರುತಿನ ಪರಿಶೀಲನೆ",
    verificationHint: "ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಮತ್ತು ಲಿಸ್ಟಿಂಗ್‌ಗಳಲ್ಲಿ ವೆರಿಫೈಡ್ ಬ್ಯಾಡ್ಜ್ ಪಡೆಯಲು ಸರ್ಕಾರಿ ಗುರುತಿನ ಚೀಟಿಯನ್ನು (ಮುಂಭಾಗ ಮತ್ತು ಹಿಂಭಾಗ) ಅಪ್‌ಲೋಡ್ ಮಾಡಿ.",
    verificationSubmit: "ಪರಿಶೀಲನೆಗಾಗಿ ಸಲ್ಲಿಸಿ",
    verificationSubmitted: "ಪರಿಶೀಲನೆಗಾಗಿ ಸಲ್ಲಿಸಲಾಗಿದೆ",
    errIdPhotosRequired: "ನಿಮ್ಮ ಗುರುತಿನ ಚೀಟಿಯ ಮುಂಭಾಗ ಮತ್ತು ಹಿಂಭಾಗ ಎರಡನ್ನೂ ಸೇರಿಸಿ",
    verificationVerified: "ನೀವು ಪರಿಶೀಲಿಸಲ್ಪಟ್ಟಿದ್ದೀರಿ",
    verificationPending: "ಪರಿಶೀಲನೆ ಬಾಕಿ ಇದೆ",
    verificationPendingSub: "ಪರಿಶೀಲನೆಯಾದ ತಕ್ಷಣ ನಾವು ನಿಮಗೆ ತಿಳಿಸುತ್ತೇವೆ — ಸಾಮಾನ್ಯವಾಗಿ ಒಂದೆರಡು ದಿನಗಳಲ್ಲಿ.",
    verificationRejected: "ಪರಿಶೀಲನೆ ಅನುಮೋದನೆಯಾಗಿಲ್ಲ",
    changePasswordTitle: "ಪಾಸ್‌ವರ್ಡ್ ಬದಲಾಯಿಸಿ",
    currentPasswordLabel: "ಪ್ರಸ್ತುತ ಪಾಸ್‌ವರ್ಡ್",
    errCurrentPasswordRequired: "ನಿಮ್ಮ ಪ್ರಸ್ತುತ ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ",
    passwordChanged: "ಪಾಸ್‌ವರ್ಡ್ ಬದಲಾಗಿದೆ",
    changePasswordButton: "ಪಾಸ್‌ವರ್ಡ್ ಅಪ್‌ಡೇಟ್ ಮಾಡಿ",
  },
  notifications: {
    title: "ನೋಟಿಫಿಕೇಶನ್‌ಗಳು",
    enabledToast: "ನೋಟಿಫಿಕೇಶನ್‌ಗಳು ಆನ್ ಆಗಿವೆ",
    disabledToast: "ನೋಟಿಫಿಕೇಶನ್‌ಗಳು ಆಫ್ ಆಗಿವೆ",
    couldNotEnableToast: "ನೋಟಿಫಿಕೇಶನ್‌ಗಳನ್ನು ಆನ್ ಮಾಡಲು ಆಗಲಿಲ್ಲ",
    notConfigured: "ಈ ಸರ್ವರ್‌ನಲ್ಲಿ ನೋಟಿಫಿಕೇಶನ್‌ಗಳು ಇನ್ನೂ ಸೆಟಪ್ ಆಗಿಲ್ಲ",
    deniedHint: "ನಿಮ್ಮ ಡಿವೈಸ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳಲ್ಲಿ ಈ ಆ್ಯಪ್‌ಗಾಗಿ ನೋಟಿಫಿಕೇಶನ್‌ಗಳು ಬ್ಲಾಕ್ ಆಗಿವೆ.",
    markAllRead: "ಎಲ್ಲವನ್ನೂ ಓದಿದಂತೆ ಗುರುತಿಸಿ",
    emptyState: "ಇನ್ನೂ ಯಾವುದೇ ನೋಟಿಫಿಕೇಶನ್‌ಗಳಿಲ್ಲ.",
  },
  refer: {
    title: "ರೆಫರ್ ಮಾಡಿ ಗಳಿಸಿ",
    heroTitle: "1 ತಿಂಗಳು ಕೊಡಿ, 1 ತಿಂಗಳು ಪಡೆಯಿರಿ",
    heroSub: "ನಿಮ್ಮ ಸ್ನೇಹಿತರನ್ನು ToLetBook ಗೆ ಆಹ್ವಾನಿಸಿ. ಅವರು ಆ್ಯಪ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ ಪ್ರಾರಂಭಿಸಿದ ತಕ್ಷಣ — ಓನರ್ ಆಗಿ ತಮ್ಮ ಮೊದಲ ಪ್ರಾಪರ್ಟಿಯನ್ನು ಲಿಸ್ಟ್ ಮಾಡಿದರೂ, ಅಥವಾ ಟೆನೆಂಟ್ ಆಗಿ ತಮ್ಮ ಮೊದಲ ಕಾಂಟ್ಯಾಕ್ಟ್ ಅನ್ನು ಅನ್‌ಲಾಕ್ ಮಾಡಿದರೂ — ನೀವಿಬ್ಬರಿಗೂ 1 ತಿಂಗಳ Pro ಉಚಿತವಾಗಿ ಸಿಗುತ್ತದೆ.",
    yourCodeLabel: "ನಿಮ್ಮ ರೆಫರಲ್ ಕೋಡ್",
    shareButton: "ಆಹ್ವಾನ ಶೇರ್ ಮಾಡಿ",
    copiedToast: "ರೆಫರಲ್ ಲಿಂಕ್ ಕಾಪಿ ಆಗಿದೆ",
    statsReferred: "{count} ಆಹ್ವಾನಿಸಲಾಗಿದೆ",
    statsRewarded: "{count} ಮಂದಿಗೆ ರಿವಾರ್ಡ್ ಸಿಕ್ಕಿದೆ",
    statsRemaining: "{count} ಉಚಿತ ತಿಂಗಳುಗಳು ಬಾಕಿ",
    howItWorksTitle: "ಇದು ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ",
    step1: "ನಿಮ್ಮ ಕೋಡ್ ಅಥವಾ ಲಿಂಕ್ ಅನ್ನು ಸ್ನೇಹಿತರೊಂದಿಗೆ ಶೇರ್ ಮಾಡಿ",
    step2: "ಅವರು ToLetBook ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ ಸೈನ್ ಅಪ್ ಮಾಡುತ್ತಾರೆ",
    step3: "ಅವರು ಓನರ್ ಆಗಿ ಮೊದಲ ಪ್ರಾಪರ್ಟಿ ಲಿಸ್ಟ್ ಮಾಡುತ್ತಾರೆ, ಅಥವಾ ಟೆನೆಂಟ್ ಆಗಿ ಮೊದಲ ಕಾಂಟ್ಯಾಕ್ಟ್ ಅನ್‌ಲಾಕ್ ಮಾಡುತ್ತಾರೆ — ನೀವಿಬ್ಬರಿಗೂ 1 ತಿಂಗಳ Pro ಉಚಿತವಾಗಿ ಸಿಗುತ್ತದೆ",
    historyTitle: "ನಿಮ್ಮ ರೆಫರಲ್‌ಗಳು",
    emptyState: "ಇನ್ನೂ ಯಾವುದೇ ರೆಫರಲ್‌ಗಳಿಲ್ಲ — ಪ್ರಾರಂಭಿಸಲು ನಿಮ್ಮ ಕೋಡ್ ಶೇರ್ ಮಾಡಿ",
    statusPending: "ಅವರ ಮೊದಲ ಲಿಸ್ಟಿಂಗ್‌ಗಾಗಿ ಕಾಯುತ್ತಿದೆ",
    statusRewarded: "ರಿವಾರ್ಡ್ ಸಿಕ್ಕಿದೆ — 1 ತಿಂಗಳು ಉಚಿತ",
    statusCapped: "ಅವರಿಗೆ ರಿವಾರ್ಡ್ ಸಿಕ್ಕಿದೆ — ನಿಮ್ಮ ಮಿತಿ ಮುಗಿದಿದೆ",
    shareMessage: "ನನ್ನೊಂದಿಗೆ ToLetBook ಸೇರಿ! ಸೈನ್ ಅಪ್ ಮಾಡುವಾಗ ನನ್ನ ರೆಫರಲ್ ಕೋಡ್ {code} ಬಳಸಿ — ನಾವಿಬ್ಬರಿಗೂ 1 ತಿಂಗಳ Pro ಉಚಿತವಾಗಿ ಸಿಗುತ್ತದೆ.",
  },
  ownerTerms: {
    intro: "ToLetBook ಬಳಸುವ ಮೂಲಕ ನೀವು ಈ ನಿಯಮಗಳಿಗೆ ಒಪ್ಪುತ್ತೀರಿ.",
    bullet1: "ToLetBook ಮೂಲಕ ಮಾಡುವ ಬಾಡಿಗೆ ಮತ್ತು ಡೆಪಾಸಿಟ್ ಪಾವತಿಗಳನ್ನು Razorpay ಮೂಲಕ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತದೆ. ToLetBook ಬ್ಯಾಂಕ್ ಅಲ್ಲ ಮತ್ತು Razorpay ದೃಢೀಕರಿಸುವುದನ್ನು ಮೀರಿ ಯಾವುದೇ ಫಲಿತಾಂಶದ ಖಾತ್ರಿ ನೀಡುವುದಿಲ್ಲ.",
    bullet2: "ನೀವು ನಮೂದಿಸುವ ಪ್ರಾಪರ್ಟಿ, ಟೆನೆಂಟ್ ಮತ್ತು ಪಾವತಿಯ ಮಾಹಿತಿ ಸರಿಯಾಗಿರುವುದು ನಿಮ್ಮ ಜವಾಬ್ದಾರಿ.",
    bullet3: "ನೀವು ನಮೂದಿಸುವ ಪ್ರಾಪರ್ಟಿ, ಟೆನೆಂಟ್ ಮತ್ತು ಪಾವತಿಯ ಮಾಹಿತಿ ಈ ಡೆಮೊಗಾಗಿ ಮಾತ್ರ ಸಂಗ್ರಹಿಸಲಾಗುತ್ತದೆ, ಯಾವುದೇ ಮೂರನೇ ವ್ಯಕ್ತಿಯೊಂದಿಗೆ ಹಂಚಿಕೊಳ್ಳುವುದಿಲ್ಲ.",
    bullet4: "ರಿಪೋರ್ಟ್‌ಗಳು ಮತ್ತು ನೋಟ್‌ಬುಕ್‌ನಲ್ಲಿನ ಅಂಕಿಅಂಶಗಳು ನೀವು ನಮೂದಿಸಿದ ಡೇಟಾದಿಂದ ನೇರವಾಗಿ ಲೆಕ್ಕ ಹಾಕಲಾಗುತ್ತದೆ — ಆಡಿಟ್ ಅಥವಾ ಪರಿಶೀಲಿಸಲಾಗಿಲ್ಲ.",
    bullet5: "ಮ್ಯಾಪ್ ಮತ್ತು ಲೊಕೇಶನ್ ವೈಶಿಷ್ಟ್ಯಗಳನ್ನು Google Maps ಒದಗಿಸುತ್ತದೆ, ಇವು Google ನ ಸ್ವಂತ ನಿಯಮಗಳಿಗೆ ಒಳಪಟ್ಟಿರುತ್ತವೆ.",
  },
  tenantTerms: {
    intro: "ToLetBook ಬಳಸುವ ಮೂಲಕ ನೀವು ಈ ನಿಯಮಗಳಿಗೆ ಒಪ್ಪುತ್ತೀರಿ.",
    bullet1: "ToLetBook ಮೂಲಕ ಮಾಡುವ ಬಾಡಿಗೆ ಮತ್ತು ಡೆಪಾಸಿಟ್ ಪಾವತಿಗಳನ್ನು Razorpay ಮೂಲಕ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತದೆ. ToLetBook ಬ್ಯಾಂಕ್ ಅಲ್ಲ ಮತ್ತು Razorpay ದೃಢೀಕರಿಸುವುದನ್ನು ಮೀರಿ ಯಾವುದೇ ಫಲಿತಾಂಶದ ಖಾತ್ರಿ ನೀಡುವುದಿಲ್ಲ.",
    bullet2: "ನೀವು ನೀಡುವ ಮಾಹಿತಿ ಸರಿಯಾಗಿರುವುದು ನಿಮ್ಮ ಜವಾಬ್ದಾರಿ.",
    bullet3: "ನೀವು ನಮೂದಿಸುವ ಪ್ರಾಪರ್ಟಿ, ಟೆನೆಂಟ್ ಮತ್ತು ಪಾವತಿಯ ಮಾಹಿತಿ ಈ ಡೆಮೊಗಾಗಿ ಮಾತ್ರ ಸಂಗ್ರಹಿಸಲಾಗುತ್ತದೆ, ಯಾವುದೇ ಮೂರನೇ ವ್ಯಕ್ತಿಯೊಂದಿಗೆ ಹಂಚಿಕೊಳ್ಳುವುದಿಲ್ಲ.",
    bullet4: "ತೋರಿಸಿದ ಅಂಕಿಅಂಶಗಳು ನೀವು ಅಥವಾ ನಿಮ್ಮ ಓನರ್ ನಮೂದಿಸಿದ ಡೇಟಾದಿಂದ ನೇರವಾಗಿ ಲೆಕ್ಕ ಹಾಕಲಾಗುತ್ತದೆ — ಆಡಿಟ್ ಅಥವಾ ಪರಿಶೀಲಿಸಲಾಗಿಲ್ಲ.",
    bullet5: "ಮ್ಯಾಪ್ ಮತ್ತು ಲೊಕೇಶನ್ ವೈಶಿಷ್ಟ್ಯಗಳನ್ನು Google Maps ಒದಗಿಸುತ್ತದೆ, ಇವು Google ನ ಸ್ವಂತ ನಿಯಮಗಳಿಗೆ ಒಳಪಟ್ಟಿರುತ್ತವೆ.",
  },
  ownerHome: {
    sectionTitlePg: "ನಿಮ್ಮ ಪಿಜಿಗಳು",
    sectionTitleProperties: "ನಿಮ್ಮ ಪ್ರಾಪರ್ಟಿಗಳು",
    thisMonth: "ಈ ತಿಂಗಳು",
    pctCollected: "{pct}% ಸಂಗ್ರಹವಾಗಿದೆ",
    received: "ಸ್ವೀಕರಿಸಲಾಗಿದೆ",
    pending: "ಬಾಕಿ",
    remindAll: "ಎಲ್ಲರಿಗೂ ರಿಮೈಂಡ್ ಮಾಡಿ",
    remindersSent: "{count} ಬಾಡಿಗೆದಾರರಿಗೆ ರಿಮೈಂಡರ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    couldNotSendReminders: "ರಿಮೈಂಡರ್‌ಗಳನ್ನು ಕಳುಹಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ",
    bedOccupancy: "ಬೆಡ್ ಆಕ್ಯುಪೆನ್ಸಿ",
    bedsFraction: "{filled}/{total} ಬೆಡ್‌ಗಳು",
    acrossPg: "ಒಟ್ಟು {count} ಪಿಜಿ {unit}",
    pgUnitSingular: "ಪ್ರಾಪರ್ಟಿ",
    pgUnitPlural: "ಪ್ರಾಪರ್ಟಿಗಳು",
    totalCount: "ಒಟ್ಟು {count}",
    addPropertyAria: "ಪ್ರಾಪರ್ಟಿ ಸೇರಿಸಿ",
    addUnitFab: "ಯುನಿಟ್ ಸೇರಿಸಿ",
    sendWhatsappReceiptBtn: "WhatsApp ರಸೀದಿ ಕಳುಹಿಸಿ",
    directUpiPayLinkBtn: "ಡೈರೆಕ್ಟ್ UPI ಪೇ ಲಿಂಕ್",
    whatsappReceiptMessage: "ಹಾಯ್ {tenant}, {property} ಗಾಗಿ ನಿಮ್ಮ ಬಾಡಿಗೆ ರಸೀದಿ: {amount} ({status}). - {owner}, ToLetBook ಮೂಲಕ",
    upiPayLinkMessage: "ಹಾಯ್ {tenant}, ದಯವಿಟ್ಟು {property} ಗೆ ಈ ತಿಂಗಳ ಬಾಡಿಗೆ ({amount}) UPI ಮೂಲಕ ಪಾವತಿಸಿ: {link} - {owner}, ToLetBook ಮೂಲಕ",
    noTenantPhone: "ಈ ಬಾಡಿಗೆದಾರರ ಫೋನ್ ನಂಬರ್ ದಾಖಲಾಗಿಲ್ಲ",
    noUpiIdSet: "ಮೊದಲು ಸೆಟ್ಟಿಂಗ್ಸ್‌ನಲ್ಲಿ ನಿಮ್ಮ UPI ID ಸೇರಿಸಿ",
    tabProperty: "ಪ್ರಾಪರ್ಟಿ",
    tabPg: "ಪಿಜಿ",
    emptyNoProperties: "ಇನ್ನೂ ಯಾವುದೇ ಪ್ರಾಪರ್ಟಿ ಇಲ್ಲ. ನಿಮ್ಮ ಮೊದಲ ಪ್ರಾಪರ್ಟಿ ಸೇರಿಸಲು + ಟ್ಯಾಪ್ ಮಾಡಿ.",
    emptyNoIndependent: "ಇನ್ನೂ ಯಾವುದೇ ಇಂಡಿಪೆಂಡೆಂಟ್ ಪ್ರಾಪರ್ಟಿ ಇಲ್ಲ.",
    emptyNoPg: "ಇನ್ನೂ ಯಾವುದೇ ಪಿಜಿ ಪ್ರಾಪರ್ಟಿ ಇಲ್ಲ.",
    emptyNoCommercial: "ಇನ್ನೂ ಯಾವುದೇ ಕಮರ್ಷಿಯಲ್ ಪ್ರಾಪರ್ಟಿ ಇಲ್ಲ.",
    filterAll: "ಎಲ್ಲಾ",
    filterResidential: "ರೆಸಿಡೆನ್ಶಿಯಲ್",
    filterCommercial: "ಕಮರ್ಷಿಯಲ್",
    filterPg: "PG / ಹಾಸ್ಟೆಲ್",
    sqftSuffix: "ಚ.ಅಡಿ",
    listedOnMarketplace: "ಮಾರ್ಕೆಟ್‌ಪ್ಲೇಸ್‌ನಲ್ಲಿ ಲಿಸ್ಟ್ ಮಾಡಲಾಗಿದೆ",
    removedFromMarketplace: "ಮಾರ್ಕೆಟ್‌ಪ್ಲೇಸ್‌ನಿಂದ ತೆಗೆದುಹಾಕಲಾಗಿದೆ",
    couldNotUpdateListing: "ಲಿಸ್ಟಿಂಗ್ ಅಪ್‌ಡೇಟ್ ಆಗಲಿಲ್ಲ",
    rentUpdated: "ಬಾಡಿಗೆ ಅಪ್‌ಡೇಟ್ ಆಗಿದೆ",
    couldNotUpdateRent: "ಬಾಡಿಗೆ ಅಪ್‌ಡೇಟ್ ಆಗಲಿಲ್ಲ",
    maintenanceUpdated: "ಮೈಂಟೆನೆನ್ಸ್ ಅಪ್‌ಡೇಟ್ ಆಗಿದೆ",
    couldNotUpdateMaintenance: "ಮೈಂಟೆನೆನ್ಸ್ ಅಪ್‌ಡೇಟ್ ಆಗಲಿಲ್ಲ",
    paid: "ಪಾವತಿಯಾಗಿದೆ",
    tenantLabel: "ಟೆನೆಂಟ್",
    perMonth: "/ತಿಂಗಳು",
    phoneLabel: "ಫೋನ್",
    noPhoneOnFile: "ಫೋನ್ ನಂಬರ್ ದಾಖಲಾಗಿಲ್ಲ",
    aadhaarLabel: "ಆಧಾರ್",
    depositLabel: "ಡೆಪಾಸಿಟ್",
    moveInDateLabel: "ಮೂವ್-ಇನ್ ದಿನಾಂಕ",
    hideManageOptions: "ಮ್ಯಾನೇಜ್ ಆಯ್ಕೆಗಳನ್ನು ಮರೆಮಾಡಿ",
    manage: "ಮ್ಯಾನೇಜ್ ಮಾಡಿ",
    manageHouses: "ಮನೆಗಳನ್ನು ಮ್ಯಾನೇಜ್ ಮಾಡಿ",
    rentalAgreement: "ರೆಂಟಲ್ ಅಗ್ರಿಮೆಂಟ್",
    rentalReceipts: "ರೆಂಟಲ್ ರಸೀದಿಗಳು",
    modifyRent: "ಬಾಡಿಗೆ ಬದಲಾಯಿಸಿ",
    maintenanceMenu: "ಮೈಂಟೆನೆನ್ಸ್",
    removeTenant: "ಟೆನೆಂಟ್ ತೆಗೆದುಹಾಕಿ",
    newRentLabel: "ಹೊಸ ಬಾಡಿಗೆ / ತಿಂಗಳು",
    save: "ಸೇವ್ ಮಾಡಿ",
    maintenancePerMonthLabel: "ಮೈಂಟೆನೆನ್ಸ್ / ತಿಂಗಳು",
    vacantBadge: "ಖಾಲಿ",
    expectedRentLabel: "ನಿರೀಕ್ಷಿತ ಬಾಡಿಗೆ",
    depositSuffix: " · ಡೆಪಾಸಿಟ್ {amount}",
    maintenanceLine: "+ {amount}/ತಿಂಗಳು ಮೈಂಟೆನೆನ್ಸ್",
    listOnToLet: "TO-LET ಮಾರ್ಕೆಟ್‌ಪ್ಲೇಸ್‌ನಲ್ಲಿ ಲಿಸ್ಟ್ ಮಾಡಿ",
    liveVisible: "ಲೈವ್ · ಬಾಡಿಗೆದಾರರಿಗೆ ಕಾಣಿಸುತ್ತದೆ",
    notListedYet: "ಇನ್ನೂ ಲಿಸ್ಟ್ ಮಾಡಿಲ್ಲ",
    toggleToLetAria: "TO-LET ಟಾಗಲ್ ಮಾಡಿ",
    addTenantButton: "ಟೆನೆಂಟ್ ಸೇರಿಸಿ",
    occBoys: "ಬಾಯ್ಸ್ ಪಿಜಿ",
    occGirls: "ಗರ್ಲ್ಸ್ ಪಿಜಿ",
    occCoEd: "ಕೋ-ಎಡ್ ಪಿಜಿ",
    occDefault: "ಪಿಜಿ",
    listVacantBedsToLet: "ಖಾಲಿ ಬೆಡ್‌ಗಳನ್ನು TO-LET ನಲ್ಲಿ ಲಿಸ್ಟ್ ಮಾಡಿ",
    fullyOccupied: "ಸಂಪೂರ್ಣ ಭರ್ತಿಯಾಗಿದೆ · ಯಾವುದೇ ಬೆಡ್ ಖಾಲಿ ಇಲ್ಲ",
  },
  ownerListings: {
    propertyAdded: "ಪ್ರಾಪರ್ಟಿ ಸೇರಿಸಲಾಗಿದೆ",
    upgradeToastMsg: "ನೀವು ನಿಮ್ಮ ಪ್ಲಾನ್‌ನ ಲಿಸ್ಟಿಂಗ್ ಮಿತಿಯನ್ನು ತಲುಪಿದ್ದೀರಿ — ಅಪ್‌ಗ್ರೇಡ್ ಆಯ್ಕೆಗಳಿಗೆ ಮರುನಿರ್ದೇಶಿಸಲಾಗುತ್ತಿದೆ.",
    heading: "ನನ್ನ ಪ್ರಾಪರ್ಟಿಗಳು",
    addLink: "+ ಸೇರಿಸಿ ›",
    emptyState: "ಇನ್ನೂ ಯಾವುದೇ ಪ್ರಾಪರ್ಟಿ ಇಲ್ಲ — ನಿಮ್ಮ ಮೊದಲನೆಯದನ್ನು ಸೇರಿಸಿ.",
    confirmDelete: '"{label}" ಅನ್ನು ಡಿಲೀಟ್ ಮಾಡಬೇಕೆ? ಇದನ್ನು ಮತ್ತೆ ಪಡೆಯಲಾಗುವುದಿಲ್ಲ.',
    propertyDeleted: "ಪ್ರಾಪರ್ಟಿ ಡಿಲೀಟ್ ಆಗಿದೆ",
    confirmDeleteHouse: '"{label}" ಅನ್ನು ತೆಗೆದುಹಾಕುವುದೇ? ಇದನ್ನು ಹಿಂತಿರುಗಿಸಲಾಗುವುದಿಲ್ಲ.',
    houseRemoved: "ಮನೆ ತೆಗೆದುಹಾಕಲಾಗಿದೆ",
    houseUpdated: "ಮನೆಯ ವಿವರಗಳು ಅಪ್‌ಡೇಟ್ ಆಗಿವೆ",
    listedOnMarketplace: "ಮಾರ್ಕೆಟ್‌ಪ್ಲೇಸ್‌ನಲ್ಲಿ ಲಿಸ್ಟ್ ಮಾಡಲಾಗಿದೆ",
    removedFromMarketplace: "ಮಾರ್ಕೆಟ್‌ಪ್ಲೇಸ್‌ನಿಂದ ತೆಗೆದುಹಾಕಲಾಗಿದೆ",
    couldNotUpdateListing: "ಲಿಸ್ಟಿಂಗ್ ಅಪ್‌ಡೇಟ್ ಆಗಲಿಲ್ಲ",
    vacantBedsFraction: "{vacant} / {total} ಖಾಲಿ",
    listOnToLet: "TO-LET ಮಾರ್ಕೆಟ್‌ಪ್ಲೇಸ್‌ನಲ್ಲಿ ಲಿಸ್ಟ್ ಮಾಡಿ",
    listVacantBedsToLet: "ಖಾಲಿ ಬೆಡ್‌ಗಳನ್ನು TO-LET ನಲ್ಲಿ ಲಿಸ್ಟ್ ಮಾಡಿ",
    liveVisible: "ಲೈವ್ · ಬಾಡಿಗೆದಾರರಿಗೆ ಕಾಣಿಸುತ್ತದೆ",
    notListedYet: "ಇನ್ನೂ ಲಿಸ್ಟ್ ಮಾಡಿಲ್ಲ",
    toggleToLetAria: "TO-LET ಟಾಗಲ್ ಮಾಡಿ",
    moreOptionsAria: "ಇನ್ನಷ್ಟು ಆಯ್ಕೆಗಳು",
    editDetails: "ವಿವರಗಳನ್ನು ಎಡಿಟ್ ಮಾಡಿ",
    deleteProperty: "ಪ್ರಾಪರ್ಟಿ ಡಿಲೀಟ್ ಮಾಡಿ",
    expectedRentLabel: "ನಿರೀಕ್ಷಿತ ಬಾಡಿಗೆ",
    depositLabel: "ಡೆಪಾಸಿಟ್",
    noPhoneOnFile: "ಫೋನ್ ನಂಬರ್ ದಾಖಲಾಗಿಲ್ಲ",
    perMonth: "/ತಿಂಗಳು",
    endTenancyButton: "ಟೆನೆನ್ಸಿ ಮುಗಿಸಿ",
    editTenantButton: "ಟೆನೆಂಟ್ ಮಾಡಿಫೈ ಮಾಡಿ",
    saveTenantButton: "ಬದಲಾವಣೆಗಳನ್ನು ಉಳಿಸಿ",
    tenantAdded: "ಟೆನೆಂಟ್ ಸೇರಿಸಲಾಗಿದೆ",
    tenantUpdated: "ಟೆನೆಂಟ್ ವಿವರಗಳು ಅಪ್‌ಡೇಟ್ ಆಗಿವೆ",
    roomAdded: "ಕೋಣೆ ಸೇರಿಸಲಾಗಿದೆ",
    couldNotAddRoom: "ಕೋಣೆ ಸೇರಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ",
    addTenantLink: "+ ಟೆನೆಂಟ್ ಸೇರಿಸಿ",
    installAppPromptTitle: "{name} ಇನ್ನೂ ToLetBook ಇನ್‌ಸ್ಟಾಲ್ ಮಾಡಿಲ್ಲ",
    installAppPromptBody: "ಅವರು ತಮ್ಮ ಅಗ್ರಿಮೆಂಟ್ ನೋಡಲು ಮತ್ತು ಮೂವ್-ಇನ್ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಲು ಆ್ಯಪ್ ಅನ್ನು ಶೇರ್ ಮಾಡಿ.",
    notifyTenantPromptTitle: "WhatsApp ನಲ್ಲಿ {name} ಗೆ ತಿಳಿಸಿ",
    notifyTenantPromptBody: "ಅವರು ಆ್ಯಪ್ ತೆರೆದು ಮೂವ್-ಇನ್ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಲು ಇದನ್ನು ಶೇರ್ ಮಾಡಿ.",
    shareOnWhatsappBtn: "💬 WhatsApp ನಲ್ಲಿ ಶೇರ್ ಮಾಡಿ",
    installAppWhatsappMessage: "ನಮಸ್ಕಾರ, ನಾನು ToLetBook ನಿಂದ {owner}. ನಾನು ನಿಮ್ಮನ್ನು \"{property}\" ಗಾಗಿ ಟೆನೆಂಟ್ ಆಗಿ ಸೇರಿಸಿದ್ದೇನೆ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ಬಾಡಿಗೆ, ಅಗ್ರಿಮೆಂಟ್ ನೋಡಲು ಮತ್ತು ಮೂವ್-ಇನ್ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಲು ಆ್ಯಪ್ ಇನ್‌ಸ್ಟಾಲ್ ಮಾಡಿ: {link}",
    notifyTenantWhatsappMessage: "ನಮಸ್ಕಾರ, ನಾನು ToLetBook ನಿಂದ {owner}. ನಾನು ನಿಮ್ಮನ್ನು \"{property}\" ಗಾಗಿ ಟೆನೆಂಟ್ ಆಗಿ ಸೇರಿಸಿದ್ದೇನೆ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ಬಾಡಿಗೆ, ಅಗ್ರಿಮೆಂಟ್ ನೋಡಲು ಮತ್ತು ಮೂವ್-ಇನ್ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಲು ಆ್ಯಪ್ ತೆರೆಯಿರಿ: {link}",
    editButton: "ಎಡಿಟ್ ಮಾಡಿ",
    deleteButton: "ಡಿಲೀಟ್ ಮಾಡಿ",
    perBed: "{amount}/ಬೆಡ್",
    priceTiers: "{count} ಬೆಲೆ ಶ್ರೇಣಿಗಳು",
    occupiedFraction: "{occupied}/{total} ಭರ್ತಿಯಾಗಿದೆ",
    occupiedBadge: "ಭರ್ತಿಯಾಗಿದೆ",
    vacantBadge: "ಖಾಲಿ",
    rentalAgreementButton: "ರೆಂಟಲ್ ಅಗ್ರಿಮೆಂಟ್",
    rentalReceiptsButton: "ಬಾಡಿಗೆ ರಸೀದಿಗಳು",
    noReceiptsYet: "ಇನ್ನೂ ಪಾವತಿಸಿದ ರಸೀದಿಗಳಿಲ್ಲ.",
    receiptsBackLink: "‹ ಹಿಂದೆ",
    loadingReceipts: "ಲೋಡ್ ಆಗುತ್ತಿದೆ…",
  },
  assignTenantForm: {
    contactPickerUnsupported: "ಈ ಡಿವೈಸ್/ಬ್ರೌಸರ್‌ನಲ್ಲಿ ಕಾಂಟ್ಯಾಕ್ಟ್ ಪಿಕರ್ ಬೆಂಬಲಿಸುವುದಿಲ್ಲ",
    errNameRequired: "ಟೆನೆಂಟ್ ಹೆಸರು ಅಗತ್ಯವಿದೆ",
    newTenant: "ಹೊಸ ಟೆನೆಂಟ್",
    existingTenant: "ಈಗಾಗಲೇ ಇರುವ ಟೆನೆಂಟ್",
    addFromContacts: "ಕಾಂಟ್ಯಾಕ್ಟ್‌ಗಳಿಂದ ಸೇರಿಸಿ",
    emptyExistingTenants: "ನಿಮ್ಮ ಪ್ರಾಪರ್ಟಿಗಳಲ್ಲಿ ಇನ್ನೂ ಬೇರೆ ಯಾವುದೇ ಟೆನೆಂಟ್ ಇಲ್ಲ.",
    noPhoneOnFile: "ಫೋನ್ ನಂಬರ್ ದಾಖಲಾಗಿಲ್ಲ",
    tenantNameLabel: "ಟೆನೆಂಟ್ ಹೆಸರು",
    phoneLabel: "ಫೋನ್ (ನೋಂದಾಯಿಸಿದ್ದರೆ, ಅವರ ToLetBook ಖಾತೆಗೆ ಹೊಂದಿಕೆಯಾಗುತ್ತದೆ)",
    phonePlaceholder: "10 ಅಂಕಿಗಳ ನಂಬರ್",
    aadhaarLabel: "ಆಧಾರ್ (ಐಚ್ಛಿಕ)",
    aadhaarPhotosLabel: "ಆಧಾರ್ ಫೋಟೋಗಳು (ಐಚ್ಛಿಕ)",
    aadhaarFront: "ಮುಂಭಾಗ",
    aadhaarBack: "ಹಿಂಭಾಗ",
    removeAadhaarPhotoAria: "ಫೋಟೋ ತೆಗೆದುಹಾಕಿ",
    rentLabel: "ಬಾಡಿಗೆ / ತಿಂಗಳು",
    depositLabel: "ಡೆಪಾಸಿಟ್",
    dateOfOccupancyLabel: "ವಾಸ ಆರಂಭದ ದಿನಾಂಕ",
    dateHint: "ಅವರು ಈಗಾಗಲೇ ಇಲ್ಲಿ ವಾಸಿಸುತ್ತಿದ್ದರೆ, ಅವರು ನಿಜವಾಗಿ ಬಂದ ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆಮಾಡಿ — ಇಂದಿನದಲ್ಲ.",
    rentDueDayLabel: "ಬಾಡಿಗೆ ಪಾವತಿ ದಿನಾಂಕ",
    rentDueDayHint: "ತಿಂಗಳಲ್ಲಿ ಬಾಡಿಗೆ ಪಾವತಿಸಬೇಕಾದ ದಿನ (1–31). ಡೀಫಾಲ್ಟ್ ಆಗಿ ವಾಸ ಆರಂಭದ ದಿನಾಂಕ ಇರುತ್ತದೆ.",
    noticePeriodLabel: "ನೋಟಿಸ್ ಅವಧಿ (ದಿನಗಳು)",
    noticePeriodHint: "ಟೆನೆಂಟ್ ಖಾಲಿ ಮಾಡುವ ಮೊದಲು ಎಷ್ಟು ನೋಟಿಸ್ ನೀಡಬೇಕು. ಡೀಫಾಲ್ಟ್ ಆಗಿ 60 ದಿನಗಳು (2 ತಿಂಗಳು) ಇರುತ್ತದೆ.",
    addTenantButton: "ಟೆನೆಂಟ್ ಸೇರಿಸಿ",
  },
  addPropertyForm: {
    errNameRequired: "ಪ್ರಾಪರ್ಟಿಗೆ ಒಂದು ಹೆಸರು ಕೊಡಿ",
    errLocalityRequired: "ಪ್ರದೇಶ ನಮೂದಿಸಿ",
    errCityRequired: "ನಗರ ನಮೂದಿಸಿ",
    errStateRequired: "ರಾಜ್ಯ ಆಯ್ಕೆಮಾಡಿ",
    errPincodeRequired: "ಪಿನ್‌ಕೋಡ್ ನಮೂದಿಸಿ",
    errFurnishingRequired: "ಫರ್ನಿಶಿಂಗ್ ಸ್ಥಿತಿ ಆಯ್ಕೆಮಾಡಿ",
    errCommunityTypeRequired: "ಸಮುದಾಯ ಪ್ರಕಾರ ಆಯ್ಕೆಮಾಡಿ",
    errRentRequired: "ನಿರೀಕ್ಷಿತ ಬಾಡಿಗೆ ನಮೂದಿಸಿ",
    errDepositRequired: "ನಿರೀಕ್ಷಿತ ಠೇವಣಿ ನಮೂದಿಸಿ",
    upgradeNowBtn: "ಈಗಲೇ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ",
    heading: "ಪ್ರಾಪರ್ಟಿ ಸೇರಿಸಿ",
    localityLabel: "ಏರಿಯಾ",
    localityPlaceholder: "ಉದಾ. ಇಂದಿರಾನಗರ, ಬೆಂಗಳೂರು",
    cityLabel: "ನಗರ",
    cityPlaceholder: "ಉದಾ. ಬೆಂಗಳೂರು",
    stateLabel: "ರಾಜ್ಯ",
    statePlaceholder: "ರಾಜ್ಯ ಆಯ್ಕೆಮಾಡಿ",
    pincodeLabel: "ಪಿನ್‌ಕೋಡ್",
    pincodePlaceholder: "6 ಅಂಕಿಗಳ ಪಿನ್‌ಕೋಡ್",
    chipIndependent: "ಇಂಡಿಪೆಂಡೆಂಟ್",
    chipPgHostel: "ಪಿಜಿ / ಹಾಸ್ಟೆಲ್",
    chipCommercial: "ಕಮರ್ಷಿಯಲ್",
    propertyNameLabel: "ಪ್ರಾಪರ್ಟಿ ಹೆಸರು",
    propertyNamePlaceholder: "ಉದಾ. 3, ರೋಸ್‌ವುಡ್ ಅಪಾರ್ಟ್‌ಮೆಂಟ್ಸ್",
    typeLabel: "ಟೈಪ್",
    expectedRentLabel: "ನಿರೀಕ್ಷಿತ ಬಾಡಿಗೆ",
    expectedDepositLabel: "ನಿರೀಕ್ಷಿತ ಡೆಪಾಸಿಟ್",
    maintenanceLabel: "ಮೈಂಟೆನೆನ್ಸ್ / ತಿಂಗಳು (ಐಚ್ಛಿಕ)",
    maintenancePlaceholder: "ಉದಾ. 1500",
    multiUnitChip: "ಈ ಪ್ರಾಪರ್ಟಿಯಲ್ಲಿ ಬಹು ಮನೆಗಳಿವೆ",
    multiUnitHint: "ಬಾಡಿಗೆಗೆ ಒಂದಕ್ಕಿಂತ ಹೆಚ್ಚು ಸ್ವತಂತ್ರ ಮನೆಗಳು/ಫ್ಲಾಟ್‌ಗಳು ಇರುವ ಕಾಂಪೌಂಡ್ ಅಥವಾ ಕಟ್ಟಡಕ್ಕೆ — ಪ್ರತಿಯೊಂದಕ್ಕೂ ತನ್ನದೇ ಬಾಡಿಗೆ, ಠೇವಣಿ, ಟೆನೆಂಟ್ ಇರುತ್ತದೆ.",
    commercialDetailsHeading: "ಕಮರ್ಷಿಯಲ್ ವಿವರಗಳು",
    carpetAreaLabel: "ಕಾರ್ಪೆಟ್ ಏರಿಯಾ (ಚ.ಅಡಿ)",
    builtUpAreaLabel: "ಬಿಲ್ಟ್-ಅಪ್ ಏರಿಯಾ (ಚ.ಅಡಿ)",
    lockInMonthsLabel: "ಲಾಕ್-ಇನ್ ಅವಧಿ (ತಿಂಗಳುಗಳು)",
    rentEscalationPercentLabel: "ಬಾಡಿಗೆ ಹೆಚ್ಚಳ (%)",
    rentEscalationYearsLabel: "ಎಷ್ಟು ವರ್ಷಗಳಿಗೊಮ್ಮೆ ಹೆಚ್ಚಳ",
    possessionStatusLabel: "ಪೊಸೆಷನ್ ಸ್ಥಿತಿ",
    possession_ready: "ತಕ್ಷಣ ಲಭ್ಯ",
    possession_under_fitout: "ಫಿಟ್-ಔಟ್ ನಡೆಯುತ್ತಿದೆ",
    washroomTypeLabel: "ವಾಶ್‌ರೂಮ್",
    washroom_attached: "ಅಟ್ಯಾಚ್ಡ್",
    washroom_shared: "ಶೇರ್ಡ್",
    commercialAmenitiesLabel: "ಸೌಲಭ್ಯಗಳು",
    powerBackupChip: "ಪವರ್ ಬ್ಯಾಕಪ್",
    powerLoadDetailsLabel: "ಪವರ್ ಬ್ಯಾಕಪ್ ವಿವರಗಳು (ಐಚ್ಛಿಕ)",
    powerLoadDetailsPlaceholder: "ಉದಾ. 3-ಫೇಸ್, 100% DG ಬ್ಯಾಕಪ್",
    parkingSpotsLabel: "ಮೀಸಲಾದ ಪಾರ್ಕಿಂಗ್ (ಕಾರು/ಬೈಕ್)",
    gstChip: "ಬಾಡಿಗೆಯ ಮೇಲೆ 18% GST ಅನ್ವಯ",
    frontageChip: "ಫ್ರಂಟೇಜ್ / ಸೈನೇಜ್ ಹಕ್ಕುಗಳು",
    seatsCountLabel: "ಸೀಟುಗಳು",
    cabinsCountLabel: "ಕ್ಯಾಬಿನ್‌ಗಳು",
    meetingRoomsCountLabel: "ಮೀಟಿಂಗ್ ರೂಮ್‌ಗಳು",
    housesHeading: "ಮನೆಗಳು",
    addHouseLink: "+ ಮನೆ ಸೇರಿಸಿ ›",
    houseNameLabel: "ಮನೆಯ ಹೆಸರು",
    hasExistingTenantChip: "ಈ ಪ್ರಾಪರ್ಟಿಯಲ್ಲಿ ಈಗಾಗಲೇ ಒಬ್ಬ ಟೆನೆಂಟ್ ಇದ್ದಾರೆ",
    tenantNameLabel: "ಟೆನೆಂಟ್ ಹೆಸರು",
    phoneLabel: "ಫೋನ್ (ನೋಂದಾಯಿಸಿದ್ದರೆ, ಅವರ ToLetBook ಖಾತೆಗೆ ಹೊಂದಿಕೆಯಾಗುತ್ತದೆ)",
    phonePlaceholder: "10 ಅಂಕಿಗಳ ನಂಬರ್",
    aadhaarLabel: "ಆಧಾರ್ (ಐಚ್ಛಿಕ)",
    dateOfOccupancyLabel: "ವಾಸ ಆರಂಭದ ದಿನಾಂಕ",
    dateHint: "ಅವರು ನಿಜವಾಗಿ ಬಂದ ದಿನಾಂಕ — ಬಾಡಿಗೆ ಮತ್ತು ಡೆಪಾಸಿಟ್ ಮೇಲೆ ಕೊಟ್ಟ ನಿರೀಕ್ಷಿತ ಮೌಲ್ಯಗಳನ್ನೇ ಬಳಸುತ್ತದೆ.",
    occupancyLabel: "ಆಕ್ಯುಪೆನ್ಸಿ",
    occBoys: "ಬಾಯ್ಸ್",
    occGirls: "ಗರ್ಲ್ಸ್",
    occCoEd: "ಕೋ-ಎಡ್",
    roomsHeading: "ರೂಮ್‌ಗಳು",
    addRoomLink: "+ ರೂಮ್ ಸೇರಿಸಿ ›",
    sharingTypeLabel: "ಶೇರಿಂಗ್ ಟೈಪ್",
    rentPerBedLabel: "ಬಾಡಿಗೆ/ಬೆಡ್",
    depositPerBedLabel: "ಡೆಪಾಸಿಟ್/ಬೆಡ್",
    bedsLabel: "ಬೆಡ್‌ಗಳು",
    mealPlanLabel: "ಊಟ ಸೇರಿದೆ",
    preferredTenantsLabel: "ಇಷ್ಟದ ಟೆನೆಂಟ್‌ಗಳು",
    meal_breakfast: "ಬ್ರೇಕ್‌ಫಾಸ್ಟ್",
    meal_lunch: "ಲಂಚ್",
    meal_dinner: "ಡಿನ್ನರ್",
    tenantType_student: "ಸ್ಟೂಡೆಂಟ್",
    tenantType_professional: "ವರ್ಕಿಂಗ್ ಪ್ರೊಫೆಷನಲ್",
    roomAc: "ಎಸಿ",
    roomAttachedBathroom: "ಅಟ್ಯಾಚ್ಡ್ ಬಾತ್ರೂಮ್",
    addPropertyButton: "ಪ್ರಾಪರ್ಟಿ ಸೇರಿಸಿ",
  },
  ownerLedgers: {
    justNow: "ಈಗಷ್ಟೇ",
    minsAgo: "{mins} ನಿಮಿಷಗಳ ಹಿಂದೆ",
    hoursAgo: "{hours} ಗಂಟೆಗಳ ಹಿಂದೆ",
    daysAgo: "{days} ದಿನಗಳ ಹಿಂದೆ",
    emptyNoProperty: "ನೋಟ್‌ಬುಕ್ ಟ್ರ್ಯಾಕ್ ಮಾಡಲು ಮೊದಲು ಒಂದು ಪ್ರಾಪರ್ಟಿ ಸೇರಿಸಿ.",
    heading: "ನೋಟ್‌ಬುಕ್",
    emptyNoTenants: "ಇಲ್ಲಿ ಇನ್ನೂ ಯಾವುದೇ ಟೆನೆಂಟ್ ಇಲ್ಲ.",
    markedPaid: "ಪಾವತಿಯಾಗಿದೆ ಎಂದು ಗುರುತಿಸಲಾಗಿದೆ",
    reminderSent: "ಟೆನೆಂಟ್‌ಗೆ ರಿಮೈಂಡರ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    emptyNoActiveTenants: "ಇಲ್ಲಿ ಇನ್ನೂ ಯಾವುದೇ ಆಕ್ಟಿವ್ ಟೆನೆಂಟ್ ಇಲ್ಲ.",
    otherCategory: "ಇತರ",
    pastTenantsHeading: "ಹಿಂದಿನ ಟೆನೆಂಟ್‌ಗಳು · {count}",
    rentLedgerLabel: "ಬಾಡಿಗೆ ಲೆಡ್ಜರ್ · ಕಳೆದ 12 ತಿಂಗಳುಗಳು",
    paidFraction: "{paid}/{total} ಪಾವತಿಯಾಗಿದೆ",
    entriesLabel: "ಎಂಟ್ರಿಗಳು",
    rentPaid: "ಬಾಡಿಗೆ ಪಾವತಿಯಾಗಿದೆ",
    rentDue: "ಬಾಡಿಗೆ ಬಾಕಿ",
    markReceived: "ಸ್ವೀಕರಿಸಲಾಗಿದೆ ಎಂದು ಗುರುತಿಸಿ (ನಗದು)",
    markingBusy: "ಗುರುತಿಸಲಾಗುತ್ತಿದೆ…",
    remindAgain: "🔔 ಮತ್ತೆ ರಿಮೈಂಡ್ ಮಾಡಿ",
    remind: "🔔 ರಿಮೈಂಡ್ ಮಾಡಿ",
    sendingBusy: "ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ…",
    remindedAgo: "{time} ರಿಮೈಂಡ್ ಮಾಡಲಾಗಿದೆ",
    closeButton: "‹ ಮುಚ್ಚಿ",
    refundLabel: "ರೀಫಂಡ್",
    refundedAmount: "{amount} ರೀಫಂಡ್ ಮಾಡಲಾಗಿದೆ",
  },
  ownerReports: {
    emptyState: "ಇನ್ನೂ ಲೆಡ್ಜರ್ ಚಟುವಟಿಕೆ ಇಲ್ಲ — ಸಂಗ್ರಹ ಆರಂಭಿಸಲು ಒಬ್ಬ ಟೆನೆಂಟ್ ಸೇರಿಸಿ.",
    heading: "ರಿಪೋರ್ಟ್‌ಗಳು",
    collected: "ಸಂಗ್ರಹವಾಗಿದೆ",
    pending: "ಬಾಕಿ",
    paidOnRecord: "ರೆಕಾರ್ಡ್‌ನಲ್ಲಿ ಪಾವತಿ",
    collectionsByMonth: "ತಿಂಗಳ ಪ್ರಕಾರ ಸಂಗ್ರಹಣೆ",
    monthTooltip: "{month}: {collected} ಸಂಗ್ರಹವಾಗಿದೆ, {pending} ಬಾಕಿ",
    byProperty: "ಪ್ರಾಪರ್ಟಿ ಪ್ರಕಾರ",
    pendingAmount: "{amount} ಬಾಕಿ",
    exportCsvButton: "ಲೆಡ್ಜರ್ ಅನ್ನು CSV ಆಗಿ ಎಕ್ಸ್‌ಪೋರ್ಟ್ ಮಾಡಿ",
    hint: "ಪ್ರತಿ ಸಾಲು ಒಂದು ಲೆಡ್ಜರ್ ಎಂಟ್ರಿಯಿಂದ ಬಂದಿದೆ — ಇಲ್ಲಿ ಪ್ರತ್ಯೇಕವಾಗಿ ಯಾವುದೇ ಅಂಕಿಅಂಶಗಳನ್ನು ಸೇರಿಸಿಲ್ಲ.",
  },
  ownerRequests: {
    visitRequestsHeading: "ವಿಸಿಟ್ ರಿಕ್ವೆಸ್ಟ್‌ಗಳು",
    newCount: "{count} ಹೊಸ",
    emptyNoVisits: "ಇನ್ನೂ ಯಾವುದೇ ವಿಸಿಟ್ ರಿಕ್ವೆಸ್ಟ್ ಇಲ್ಲ.",
    maintenanceRequestsHeading: "ಮೈಂಟೆನೆನ್ಸ್ ರಿಕ್ವೆಸ್ಟ್‌ಗಳು",
    emptyNoRequests: "ಇನ್ನೂ ಯಾವುದೇ ರಿಕ್ವೆಸ್ಟ್ ಮಾಡಿಲ್ಲ.",
    noDetailsProvided: "ಯಾವುದೇ ವಿವರಗಳನ್ನು ನೀಡಿಲ್ಲ",
    startWork: "ಕೆಲಸ ಆರಂಭಿಸಿ",
    markResolved: "ಪರಿಹಾರವಾಗಿದೆ ಎಂದು ಗುರುತಿಸಿ",
    requestUpdated: "ರಿಕ್ವೆಸ್ಟ್ ಅಪ್‌ಡೇಟ್ ಆಗಿದೆ",
    visitConfirmed: "ವಿಸಿಟ್ ಕನ್‌ಫರ್ಮ್ ಆಗಿದೆ",
    visitDeclined: "ವಿಸಿಟ್ ತಿರಸ್ಕರಿಸಲಾಗಿದೆ",
    noPhoneOnFile: "ಫೋನ್ ನಂಬರ್ ದಾಖಲಾಗಿಲ್ಲ",
    visitLine: "{property} · {date} ರಂದು {time} ಗೆ",
    declineButton: "ತಿರಸ್ಕರಿಸಿ",
    confirmButton: "ಕನ್‌ಫರ್ಮ್ ಮಾಡಿ",
    statusOpen: "ಓಪನ್",
    statusInProgress: "ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    statusResolved: "ಪರಿಹಾರವಾಗಿದೆ",
    visitStatusPending: "ಬಾಕಿ ಇದೆ",
    visitStatusConfirmed: "ಕನ್‌ಫರ್ಮ್ ಆಗಿದೆ",
    visitStatusDeclined: "ತಿರಸ್ಕರಿಸಲಾಗಿದೆ",
    visitStatusCancelled: "ರದ್ದಾಗಿದೆ",
    vacateRequestsHeading: "ಖಾಲಿ ಮಾಡುವ ನೋಟಿಸ್‌ಗಳು",
    emptyNoVacates: "ಇನ್ನೂ ಯಾವುದೇ ಖಾಲಿ ಮಾಡುವ ನೋಟಿಸ್ ಇಲ್ಲ.",
    vacateLine: "{property} · {date} ರಂದು ಖಾಲಿ ಮಾಡುತ್ತಾರೆ",
    noticeGivenLine: "{date} ರಂದು ನೋಟಿಸ್ ನೀಡಲಾಗಿದೆ",
    acknowledgeButton: "ಒಪ್ಪಿಕೊಳ್ಳಿ",
    vacateAcknowledged: "ಖಾಲಿ ಮಾಡುವ ನೋಟಿಸ್ ಒಪ್ಪಿಕೊಳ್ಳಲಾಗಿದೆ",
    vacateStatusPending: "ಬಾಕಿ ಇದೆ",
    vacateStatusAcknowledged: "ಒಪ್ಪಿಕೊಳ್ಳಲಾಗಿದೆ",
    vacateStatusCancelled: "ರದ್ದಾಗಿದೆ",
  },
  editPropertyForm: {
    errNameRequired: "ಪ್ರಾಪರ್ಟಿಗೆ ಒಂದು ಹೆಸರು ಕೊಡಿ",
    propertyUpdated: "ಪ್ರಾಪರ್ಟಿ ಅಪ್‌ಡೇಟ್ ಆಗಿದೆ",
    couldNotUpdate: "ಪ್ರಾಪರ್ಟಿ ಅಪ್‌ಡೇಟ್ ಆಗಲಿಲ್ಲ",
    localityLabel: "ಏರಿಯಾ",
    propertyNameLabel: "ಪ್ರಾಪರ್ಟಿ ಹೆಸರು",
    typeLabel: "ಟೈಪ್",
    residentialGroup: "ರೆಸಿಡೆನ್ಷಿಯಲ್",
    commercialGroup: "ಕಮರ್ಷಿಯಲ್",
    expectedRentLabel: "ನಿರೀಕ್ಷಿತ ಬಾಡಿಗೆ",
    expectedDepositLabel: "ನಿರೀಕ್ಷಿತ ಡೆಪಾಸಿಟ್",
    maintenanceLabel: "ಮೈಂಟೆನೆನ್ಸ್ / ತಿಂಗಳು (ಐಚ್ಛಿಕ)",
    occupancyLabel: "ಆಕ್ಯುಪೆನ್ಸಿ",
    occBoys: "ಬಾಯ್ಸ್",
    occGirls: "ಗರ್ಲ್ಸ್",
    occCoEd: "ಕೋ-ಎಡ್",
    facilitiesLabel: "ಸೌಲಭ್ಯಗಳು",
    facility_wifi: "ವೈ-ಫೈ",
    facility_meals: "ಊಟ",
    facility_laundry: "ಲಾಂಡ್ರಿ",
    facility_powerBackup: "ಪವರ್ ಬ್ಯಾಕಪ್",
    facility_cctv: "ಸಿಸಿಟಿವಿ",
    facility_parking: "ಪಾರ್ಕಿಂಗ್",
    facility_ac: "ಎಸಿ",
    facility_tv: "ಟಿವಿ",
    facility_washingMachine: "ವಾಷಿಂಗ್ ಮೆಷಿನ್",
    perHouseFurnishingHint: "ಫರ್ನಿಷಿಂಗ್ ಅನ್ನು ಪ್ರತಿ ಮನೆಗೆ ಪ್ರತ್ಯೇಕವಾಗಿ ಹೊಂದಿಸಲಾಗುತ್ತದೆ — ಕೆಳಗೆ ಪ್ರತಿ ಮನೆಯನ್ನು ತೆರೆದು ಹೊಂದಿಸಿ.",
    furnishingStatusLabel: "ಫರ್ನಿಷಿಂಗ್",
    furnishing_unfurnished: "ಅನ್‌ಫರ್ನಿಶ್ಡ್",
    furnishing_semi_furnished: "ಸೆಮಿ-ಫರ್ನಿಶ್ಡ್",
    furnishing_fully_furnished: "ಫುಲ್ಲಿ ಫರ್ನಿಶ್ಡ್",
    commercialFurnishing_unfurnished: "ಬೇರ್ ಶೆಲ್",
    commercialFurnishing_semi_furnished: "ವಾರ್ಮ್ ಶೆಲ್",
    commercialFurnishing_fully_furnished: "ಫುಲ್ಲಿ ಫರ್ನಿಶ್ಡ್",
    communityTypeLabel: "ಕಮ್ಯುನಿಟಿ ಟೈಪ್",
    community_gated: "ಗೇಟೆಡ್ ಕಮ್ಯುನಿಟಿ",
    community_semi_gated: "ಸೆಮಿ ಗೇಟೆಡ್ ಕಮ್ಯುನಿಟಿ",
    community_villa: "ವಿಲ್ಲಾ",
    community_apartment: "ಅಪಾರ್ಟ್‌ಮೆಂಟ್",
    community_independent: "ಇಂಡಿಪೆಂಡೆಂಟ್",
    floorNumberLabel: "ಮಹಡಿ",
    floorNumberPlaceholder: "ಉದಾ. 3 ಅಥವಾ ಗ್ರೌಂಡ್",
    floorChipLabel: "ಮಹಡಿ {floor}",
    furnishingItemsLabel: "ಫರ್ನಿಚರ್ ಮತ್ತು ಉಪಕರಣಗಳು",
    furnishingItemsHint: "ಬಾಡಿಗೆದಾರರಿಗೆ ಪ್ರತಿಯೊಂದೂ ಎಷ್ಟು ಇರುತ್ತದೆ ಎಂದು ನಮೂದಿಸಿ.",
    item_fan: "ಫ್ಯಾನ್‌ಗಳು",
    item_light: "ಲೈಟ್‌ಗಳು",
    item_ac: "ಎಸಿ",
    item_fridge: "ಫ್ರಿಡ್ಜ್",
    item_washingMachine: "ವಾಷಿಂಗ್ ಮೆಷಿನ್",
    item_sofa: "ಸೋಫಾ",
    item_bed: "ಬೆಡ್",
    item_heater: "ವಾಟರ್ ಹೀಟರ್ (ಬಾತ್‌ರೂಮ್)",
    item_chimney: "ಚಿಮಣಿ (ಕಿಚನ್)",
    addFurnitureItemPlaceholder: "+ ಪೀಠೋಪಕರಣ / ಉಪಕರಣ ಸೇರಿಸಿ",
    customItemNamePlaceholder: "ಉದಾ. ಸ್ಟಡಿ ಟೇಬಲ್",
    addCustomItemBtn: "+ ಇನ್ನೊಂದು ವಸ್ತು ಸೇರಿಸಿ",
  },
  endTenancyForm: {
    tenancyEnded: "ಟೆನೆನ್ಸಿ ಮುಗಿದಿದೆ — ರೀಫಂಡ್ ವಿವರಗಳನ್ನು ಟೆನೆಂಟ್‌ಗೆ ಕಳುಹಿಸಲಾಗಿದೆ",
    couldNotEnd: "ಟೆನೆನ್ಸಿ ಮುಗಿಸಲು ಆಗಲಿಲ್ಲ",
    heading: "ಟೆನೆನ್ಸಿ ಮುಗಿಸಿ — {name}",
    dateOfExitLabel: "ನಿರ್ಗಮನ ದಿನಾಂಕ",
    depositPaidLabel: "ಪಾವತಿಸಿದ ಡೆಪಾಸಿಟ್",
    deductionsLabel: "ಕಡಿತಗಳು (ಹಾನಿ, ಬಾಕಿ ಇತ್ಯಾದಿ)",
    deductionNoteLabel: "ಕಡಿತದ ಟಿಪ್ಪಣಿ (ಐಚ್ಛಿಕ)",
    deductionNotePlaceholder: "ಉದಾ. ಗೋಡೆ ಪೇಂಟ್ ಸರಿಪಡಿಸುವಿಕೆ",
    refundableDepositLabel: "ಹಿಂತಿರುಗಿಸಬಹುದಾದ ಡೆಪಾಸಿಟ್",
    confirmButton: "ಕನ್‌ಫರ್ಮ್ ಮಾಡಿ ಮತ್ತು ಟೆನೆನ್ಸಿ ಮುಗಿಸಿ",
    endingBusy: "ಮುಗಿಸಲಾಗುತ್ತಿದೆ…",
  },
  propertyPhotos: {
    uploadFailed: "ಅಪ್‌ಲೋಡ್ ವಿಫಲವಾಗಿದೆ",
    photoRemoved: "ಫೋಟೋ ತೆಗೆದುಹಾಕಲಾಗಿದೆ",
    couldNotRemove: "ಫೋಟೋ ತೆಗೆದುಹಾಕಲು ಆಗಲಿಲ್ಲ",
    removePhotoAria: "ಫೋಟೋ ತೆಗೆದುಹಾಕಿ",
  },
  photoStager: {
    photosLabel: "ಫೋಟೋಗಳು (ಐಚ್ಛಿಕ)",
    couldNotRead: "ಆ ಇಮೇಜ್ ಓದಲು ಆಗಲಿಲ್ಲ",
    removePhotoAria: "ಫೋಟೋ ತೆಗೆದುಹಾಕಿ",
  },
  photoPickerButtons: {
    addPhotoTitle: "ಫೋಟೋ ಸೇರಿಸಿ",
    takePhoto: "📷 ಫೋಟೋ ತೆಗೆಯಿರಿ",
    chooseFromFiles: "🖼 ಫೈಲ್‌ಗಳಿಂದ ಆಯ್ಕೆಮಾಡಿ",
  },
  ownerPlans: {
    title: "ಪ್ಲಾನ್‌ಗಳು",
    currentPlanLabel: "ಪ್ರಸ್ತುತ ಪ್ಲಾನ್",
    trialBadge: "ಉಚಿತ ಪ್ರೀಮಿಯಂ ಟ್ರಯಲ್",
    trialEndsOn: "ಟ್ರಯಲ್ {date} ಕ್ಕೆ ಮುಗಿಯುತ್ತದೆ",
    renewsOn: "{date} ಕ್ಕೆ ರಿನ್ಯೂ ಆಗುತ್ತದೆ",
    listingsUsed: "{cap} ರಲ್ಲಿ {used} ಲಿಸ್ಟಿಂಗ್‌ಗಳು ಬಳಸಲಾಗಿದೆ",
    billingMonthly: "ಮಾಸಿಕ",
    billingYearly: "ವಾರ್ಷಿಕ · ~16% ಉಳಿತಾಯ",
    basicName: "ಬೇಸಿಕ್",
    proName: "ಪ್ರೊ",
    premiumName: "ಪ್ರೀಮಿಯಂ",
    mostPopular: "ಅತ್ಯಂತ ಜನಪ್ರಿಯ",
    powerOwners: "ಪವರ್ ಓನರ್‌ಗಳು",
    basicSub: "ಈಗಷ್ಟೇ ಶುರು ಮಾಡುತ್ತಿರುವ ಓನರ್‌ಗಳಿಗೆ",
    proSub: "ಕೆಲವು ಪ್ರಾಪರ್ಟಿಗಳಿರುವ ಓನರ್‌ಗಳಿಗೆ",
    premiumSub: "ಹಲವು ಪ್ರಾಪರ್ಟಿಗಳನ್ನು ನಿರ್ವಹಿಸುವ ಓನರ್‌ಗಳಿಗೆ",
    featListing1: "1 ಆಕ್ಟಿವ್ ಲಿಸ್ಟಿಂಗ್",
    featListing3: "3 ರವರೆಗೆ ಆಕ್ಟಿವ್ ಲಿಸ್ಟಿಂಗ್‌ಗಳು",
    featListingUnlimited: "ಅನಿಯಮಿತ ಲಿಸ್ಟಿಂಗ್‌ಗಳು",
    featEnquiries: "ಟೆನೆಂಟ್ ವಿಚಾರಣೆಗಳು ಮತ್ತು ವಿಸಿಟ್ ರಿಕ್ವೆಸ್ಟ್‌ಗಳು",
    featLedger: "ಬಾಡಿಗೆ ಸಂಗ್ರಹಣೆ ಮತ್ತು ಡಿಜಿಟಲ್ ಲೆಡ್ಜರ್",
    featAgreement: "ಸೆಲ್ಫ್-ಸರ್ವ್ ರೆಂಟಲ್ ಅಗ್ರಿಮೆಂಟ್ ಜನರೇಟರ್ — ಶೀಘ್ರದಲ್ಲೇ ಬರುತ್ತಿದೆ",
    featMarketplace: "TO-LET ಮಾರ್ಕೆಟ್‌ಪ್ಲೇಸ್‌ನಲ್ಲಿ ಕಾಣಿಸುತ್ತದೆ",
    featEverythingBasic: "ಬೇಸಿಕ್‌ನಲ್ಲಿರುವ ಎಲ್ಲವೂ",
    featEverythingPro: "ಪ್ರೊದಲ್ಲಿರುವ ಎಲ್ಲವೂ",
    featMarketplaceSwitch: "TO-LET ಮಾರ್ಕೆಟ್‌ಪ್ಲೇಸ್ ಸ್ವಿಚ್ — ಯಾವಾಗ ಬೇಕಾದರೂ ಲೈವ್ ಮಾಡಿ",
    featFeatured: "ಸರ್ಚ್‌ನಲ್ಲಿ ಫೀಚರ್ಡ್ ಪ್ಲೇಸ್‌ಮೆಂಟ್",
    featPriority: "ಇದೇ ರೀತಿಯ ಪ್ರಾಪರ್ಟಿ ಸಲಹೆಗಳಲ್ಲಿ ಆದ್ಯತೆ",
    featTopListing: "ಟಾಪ್ ಲಿಸ್ಟಿಂಗ್ — ಮಾರ್ಕೆಟ್‌ಪ್ಲೇಸ್ ಸರ್ಚ್‌ನ ಮೇಲ್ಭಾಗದಲ್ಲಿ ಪಿನ್ ಮಾಡಲಾಗಿದೆ",
    featPriorityAgreement: "ಆದ್ಯತೆಯ ರೆಂಟಲ್ ಅಗ್ರಿಮೆಂಟ್ ಸೇವೆ (ಕಾನೂನು-ಪರಿಶೀಲಿತ, ವೇಗದ ಟರ್ನ್‌ಅರೌಂಡ್) — ಶೀಘ್ರದಲ್ಲೇ ಬರುತ್ತಿದೆ",
    featPriorityVerification: "ಆದ್ಯತೆಯ ಗುರುತಿನ-ಪರಿಶೀಲನೆ ಸಮೀಕ್ಷೆ",
    featPrioritySupport: "ಆದ್ಯತೆಯ ಸಪೋರ್ಟ್",
    currentPlanBtn: "ಪ್ರಸ್ತುತ ಪ್ಲಾನ್",
    switchToBtn: "{plan} ಗೆ ಸ್ವಿಚ್ ಮಾಡಿ",
    noChargeNote: "ಇನ್ನೂ ಪಾವತಿ ಅಗತ್ಯವಿಲ್ಲ — ಬಿಲ್ಲಿಂಗ್ ಸೆಟಪ್ ಆಗುವವರೆಗೆ ಪ್ಲಾನ್‌ಗಳನ್ನು ಬದಲಾಯಿಸುವುದು ಉಚಿತ.",
    switchedToast: "{plan} ಪ್ಲಾನ್‌ಗೆ ಬದಲಾಯಿಸಲಾಗಿದೆ",
    switchFailedToast: "ಪ್ಲಾನ್ ಬದಲಾಯಿಸಲು ಆಗಲಿಲ್ಲ",
    trialActiveNote: "ನೀವು ಉಚಿತ ಪ್ರೀಮಿಯಂ ಟ್ರಯಲ್‌ನಲ್ಲಿದ್ದೀರಿ — ಅದು ಮುಗಿಯುವವರೆಗೆ ಪ್ರತಿ ಪ್ರೀಮಿಯಂ ಫೀಚರ್ ಅನ್‌ಲಾಕ್ ಆಗಿದೆ.",
    cancelPlanBtn: "ಪ್ಲಾನ್ ರದ್ದುಗೊಳಿಸಿ",
    securePaymentNote: "ಪಾವತಿಗಳನ್ನು Razorpay ಮೂಲಕ ಸುರಕ್ಷಿತವಾಗಿ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತದೆ.",
  },
  tenantHome: {
    moveOutSettlement: "ಮೂವ್-ಔಟ್ ಸೆಟಲ್‌ಮೆಂಟ್",
    yourLastPlace: "ನಿಮ್ಮ ಕೊನೆಯ ಜಾಗ",
    depositPaid: "ಪಾವತಿಸಿದ ಡೆಪಾಸಿಟ್",
    deductionsLabel: "ಕಡಿತಗಳು",
    refundableDeposit: "ಹಿಂತಿರುಗಿಸಬಹುದಾದ ಡೆಪಾಸಿಟ್",
    exitedOn: "{date} ರಂದು ಬಿಟ್ಟುಹೋದರು",
    noActiveTenancyLine1: "ನಿಮಗೆ ಇನ್ನೂ ಯಾವುದೇ ಆಕ್ಟಿವ್ ಟೆನೆನ್ಸಿ ಇಲ್ಲ.",
    noActiveTenancyLine2: "ಜಾಗ ಹುಡುಕಲು ಲಿಸ್ಟಿಂಗ್‌ಗಳನ್ನು ನೋಡಿ, ಅಥವಾ ಶಿಫ್ಟ್ ಆದ ನಂತರ ನಿಮ್ಮ ಓನರ್‌ಗೆ ನಿಮ್ಮನ್ನು ಸೇರಿಸಲು ಹೇಳಿ.",
    welcomeTitle: "ToLetBook ಗೆ ಸ್ವಾಗತ!",
    welcomeSub: "ನಿಮಗಾಗಿ ಬಾಡಿಗೆ ಪ್ರಾಪರ್ಟಿಯನ್ನು ಹುಡುಕೋಣ.",
    browsePropertiesBtn: "ಪ್ರಾಪರ್ಟಿಗಳನ್ನು ನೋಡಿ",
    rentForMonth: "{month} ತಿಂಗಳ ಬಾಡಿಗೆ",
    paidStatus: "ಪಾವತಿಯಾಗಿದೆ",
    dueStatus: "ಬಾಕಿ",
    overdueStatus: "ಓವರ್‌ಡ್ಯೂ",
    dueInDays: "{count} ದಿನಗಳಲ್ಲಿ ಬಾಕಿ",
    dueTodayLabel: "ಇಂದು ಬಾಕಿ",
    overdueByDays: "{count} ದಿನಗಳು ಮೀರಿದೆ",
    reminderBanner: "🔔 ಈ ಪಾವತಿಯ ಬಗ್ಗೆ ನಿಮ್ಮ ಓನರ್ ರಿಮೈಂಡರ್ ಕಳುಹಿಸಿದ್ದಾರೆ",
    paidCheck: "✓ ಪಾವತಿಯಾಗಿದೆ",
    onDate: "{date} ರಂದು",
    viaMode: "{mode} ಮೂಲಕ",
    receiptBtn: "ರಸೀದಿ",
    payingBtn: "ಪಾವತಿಸಲಾಗುತ್ತಿದೆ…",
    payAmount: "{amount} ಪಾವತಿಸಿ",
    paymentRecordedToast: "ಪಾವತಿ ದಾಖಲಾಗಿದೆ",
    ownerLabel: "ಓನರ್",
    callOwnerAria: "ಓನರ್‌ಗೆ ಕರೆ ಮಾಡಿ",
    raiseRequest: "ರಿಕ್ವೆಸ್ಟ್ ಕಳುಹಿಸಿ",
    viewLease: "ಅಗ್ರಿಮೆಂಟ್ ನೋಡಿ",
    receiptsNav: "ರಸೀದಿಗಳು",
    browseRooms: "ರೂಮ್‌ಗಳನ್ನು ನೋಡಿ",
    openRequestsHeading: "ಓಪನ್ ರಿಕ್ವೆಸ್ಟ್‌ಗಳು",
    viewAll: "ಎಲ್ಲಾ ನೋಡಿ",
    noOpenRequests: "ಯಾವುದೇ ಓಪನ್ ರಿಕ್ವೆಸ್ಟ್ ಇಲ್ಲ.",
    noDetailsProvided: "ಯಾವುದೇ ವಿವರಗಳನ್ನು ನೀಡಿಲ್ಲ",
  },
  tenantBrowse: {
    occBoys: "ಬಾಯ್ಸ್ ಪಿಜಿ",
    occGirls: "ಗರ್ಲ್ಸ್ ಪಿಜಿ",
    occCoEd: "ಕೋ-ಎಡ್ ಪಿಜಿ",
    occDefault: "ಪಿಜಿ",
    filterAll: "ಎಲ್ಲಾ",
    filterPg: "ಪಿಜಿ",
    filter1RK: "1RK",
    filter1BHK: "1BHK",
    filter2BHK: "2BHK",
    filter3BHK: "3BHK",
    filterVilla: "ವಿಲ್ಲಾ",
    filterShop: "ಅಂಗಡಿ",
    filterOffice: "ಆಫೀಸ್",
    filterShowroom: "ಶೋರೂಮ್",
    filterWarehouse: "ಗೋದಾಮು",
    filterCoworking: "ಕೋ-ವರ್ಕಿಂಗ್",
    filterFactory: "ಫ್ಯಾಕ್ಟರಿ",
    sortDefault: "ಡಿಫಾಲ್ಟ್",
    sortPriceAsc: "ಬೆಲೆ: ಕಡಿಮೆಯಿಂದ ಹೆಚ್ಚಿಗೆ",
    sortPriceDesc: "ಬೆಲೆ: ಹೆಚ್ಚಿನಿಂದ ಕಡಿಮೆಗೆ",
    sortDistance: "ದೂರ: ಹತ್ತಿರದವು ಮೊದಲು",
    locationNotSupported: "ಈ ಬ್ರೌಸರ್‌ನಲ್ಲಿ ಲೊಕೇಶನ್ ಬೆಂಬಲಿಸುವುದಿಲ್ಲ",
    locationPermissionDenied: "ಲೊಕೇಶನ್ ಅನುಮತಿ ನಿರಾಕರಿಸಲಾಗಿದೆ",
    locationCouldNotGet: "ನಿಮ್ಮ ಲೊಕೇಶನ್ ಪಡೆಯಲು ಆಗಲಿಲ್ಲ",
    heading: "ನಿಮಗಾಗಿ ToLet ಗಳನ್ನು ಹುಡುಕೋಣ",
    searchPlaceholder: "ಏರಿಯಾ ಅಥವಾ ಪ್ರಾಪರ್ಟಿ ಹೆಸರಿನಿಂದ ಹುಡುಕಿ",
    filtersBtn: "⚙ ಫಿಲ್ಟರ್‌ಗಳು",
    listView: "☰ ಲಿಸ್ಟ್ ವ್ಯೂ",
    mapView: "🗺️ ಮ್ಯಾಪ್ ವ್ಯೂ",
    fromPrice: "{price} ನಿಂದ ಆರಂಭ",
    housesCount: "{count} ಮನೆಗಳು",
    noVacancies: "ಈಗ ಯಾವುದೇ ಖಾಲಿ ಜಾಗ ಇಲ್ಲ — ನಂತರ ನೋಡಿ.",
    noMatch: "ನಿಮ್ಮ ಸರ್ಚ್ ಅಥವಾ ಫಿಲ್ಟರ್‌ಗೆ ಹೊಂದುವ ಯಾವುದೇ ಲಿಸ್ಟಿಂಗ್ ಇಲ್ಲ.",
    noPinnedLocation: "ಇವುಗಳಲ್ಲಿ ಯಾವುದೇ ಲಿಸ್ಟಿಂಗ್‌ಗೆ ಇನ್ನೂ ಲೊಕೇಶನ್ ಪಿನ್ ಮಾಡಿಲ್ಲ.",
    distanceAway: "{value} ದೂರದಲ್ಲಿ",
    filtersTitle: "ಫಿಲ್ಟರ್‌ಗಳು",
    propertyTypeLabel: "ಪ್ರಾಪರ್ಟಿ ಟೈಪ್",
    sortByLabel: "ಇದರ ಪ್ರಕಾರ ವಿಂಗಡಿಸಿ",
    yourLocationLabel: "ನಿಮ್ಮ ಲೊಕೇಶನ್",
    locating: "ಲೊಕೇಶನ್ ಪತ್ತೆಹಚ್ಚಲಾಗುತ್ತಿದೆ…",
    locationOn: "📍 ಲೊಕೇಶನ್ ಆನ್ ಆಗಿದೆ",
    useMyLocation: "📍 ನನ್ನ ಲೊಕೇಶನ್ ಬಳಸಿ",
    nearLabel: "📍 {location} ಸಮೀಪ",
    clearAll: "ಎಲ್ಲಾ ಕ್ಲಿಯರ್ ಮಾಡಿ",
    showResults: "ಫಲಿತಾಂಶಗಳನ್ನು ತೋರಿಸಿ",
    backToListings: "‹ ಲಿಸ್ಟಿಂಗ್‌ಗಳಿಗೆ ಹಿಂತಿರುಗಿ",
    housesHeading: "ಮನೆಗಳು",
    occupiedBadge: "ಭರ್ತಿಯಾಗಿದೆ",
    vacantBadge: "ಖಾಲಿ",
    typeLabel: "ಟೈಪ್",
    rentLabel: "ಬಾಡಿಗೆ",
    perMonthSuffix: "/ತಿಂಗಳು",
    depositLabel: "ಡೆಪಾಸಿಟ್",
    escalationLabel: "ಬಾಡಿಗೆ ಹೆಚ್ಚಳ",
    yearsSuffix: "ವರ್ಷಗಳು",
    occupancyLabel: "ಆಕ್ಯುಪೆನ್ಸಿ",
    mealPlanLabel: "ಊಟ ಸೇರಿದೆ",
    preferredTenantsLabel: "ಇಷ್ಟದ ಟೆನೆಂಟ್‌ಗಳು",
    roomAc: "ಎಸಿ",
    roomAttachedBathroom: "ಅಟ್ಯಾಚ್ಡ್ ಬಾತ್ರೂಮ್",
    bedsVacant: "{total} ರಲ್ಲಿ {vacant} ಬೆಡ್‌ಗಳು ಖಾಲಿ ಇವೆ",
    locationLabel: "ಲೊಕೇಶನ್",
    openInGoogleMaps: "Google Maps ನಲ್ಲಿ ತೆರೆಯಿರಿ",
    viewOnMap: "ಮ್ಯಾಪ್‌ನಲ್ಲಿ ನೋಡಿ",
    hideMap: "ಮ್ಯಾಪ್ ಮರೆಮಾಡಿ",
    showNearby: "ಹತ್ತಿರದಲ್ಲಿ ಏನಿದೆ ಎಂದು ನೋಡಿ",
    hideNearby: "ಹತ್ತಿರದ ಸ್ಥಳಗಳನ್ನು ಮರೆಮಾಡಿ",
    loadingNearby: "ಹತ್ತಿರದ ಸ್ಥಳಗಳನ್ನು ಹುಡುಕಲಾಗುತ್ತಿದೆ…",
    nearbyEmpty: "ಹತ್ತಿರದಲ್ಲಿ ಯಾವುದೇ ಸ್ಥಳಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
    nearbyTransit: "ಟ್ರಾನ್ಸಿಟ್",
    nearbyEssentials: "ಅಗತ್ಯ ವಸ್ತುಗಳು",
    nearbyHealthcare: "ಆರೋಗ್ಯ ಸೇವೆ",
    metersAway: "{distance} ಮೀ ದೂರದಲ್ಲಿ",
    similarPropertiesHeading: "ಇದೇ ರೀತಿಯ ಪ್ರಾಪರ್ಟಿಗಳು",
    topTag: "ಟಾಪ್",
    featuredTag: "ಫೀಚರ್ಡ್",
    moveInHint: "ಶಿಫ್ಟ್ ಆಗಲು, ನಿಮ್ಮ ನೋಂದಾಯಿತ ಫೋನ್ ನಂಬರ್‌ನೊಂದಿಗೆ ನಿಮ್ಮನ್ನು ಟೆನೆಂಟ್ ಆಗಿ ಸೇರಿಸಲು ಓನರ್‌ಗೆ ಹೇಳಿ — ನಂತರ ಅದು ನಿಮ್ಮ ಹೋಮ್ ಟ್ಯಾಬ್‌ನಲ್ಲಿ ತಾನಾಗಿಯೇ ಕಾಣಿಸುತ್ತದೆ.",
    scheduleVisit: "ವಿಸಿಟ್ ಶೆಡ್ಯೂಲ್ ಮಾಡಿ",
    pickDateTime: "ದಿನಾಂಕ ಮತ್ತು ಸಮಯ ಆಯ್ಕೆಮಾಡಿ",
    visitRequestSent: "ವಿಸಿಟ್ ರಿಕ್ವೆಸ್ಟ್ ಓನರ್‌ಗೆ ಕಳುಹಿಸಲಾಗಿದೆ",
    couldNotSendVisit: "ವಿಸಿಟ್ ರಿಕ್ವೆಸ್ಟ್ ಕಳುಹಿಸಲು ಆಗಲಿಲ್ಲ",
    requestedFor: "{date} ರಂದು {time} ಕ್ಕೆ ರಿಕ್ವೆಸ್ಟ್ ಕಳುಹಿಸಲಾಗಿದೆ — ಓನರ್‌ಗೆ ತಿಳಿಸಲಾಗಿದೆ, ಅವರು ಖಚಿತಪಡಿಸುತ್ತಾರೆ.",
    dateLabel: "ದಿನಾಂಕ",
    timeLabel: "ಸಮಯ",
    noteOptionalLabel: "ಟಿಪ್ಪಣಿ (ಐಚ್ಛಿಕ)",
    notePlaceholder: "ಉದಾ. ಸಂಜೆ ಬಂದರೆ ಚೆನ್ನಾಗಿರುತ್ತದೆ, ಮೊದಲೇ ಕರೆ ಮಾಡುತ್ತೇನೆ",
    sending: "ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ…",
    requestVisitBtn: "ವಿಸಿಟ್ ರಿಕ್ವೆಸ್ಟ್ ಮಾಡಿ",
    ownerContactLabel: "ಓನರ್",
    verifiedOwnerBadge: "ಪರಿಶೀಲಿತ",
    unlockingBtn: "ಅನ್‌ಲಾಕ್ ಆಗುತ್ತಿದೆ…",
    unlockNumberFreeBtn: "🔓 ನಂಬರ್ ಅನ್‌ಲಾಕ್ ಮಾಡಿ — ಉಚಿತ",
    unlockUpsellTitle: "ಉಚಿತ ಅನ್‌ಲಾಕ್ ಬಳಸಲಾಗಿದೆ",
    unlockUpsellBody: "ಬೇಸಿಕ್ ಪ್ಲಾನ್‌ನಲ್ಲಿ 1 ಓನರ್ ಕಾಂಟ್ಯಾಕ್ಟ್ ಉಚಿತವಾಗಿ ಅನ್‌ಲಾಕ್ ಆಗುತ್ತದೆ. ಅಪರಿಮಿತ ಓನರ್‌ಗಳನ್ನು ಅನ್‌ಲಾಕ್ ಮಾಡಲು Tenant Pro‌ಗೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ.",
    unlockUpsellBtn: "Tenant Pro‌ಗೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ",
    callNumberBtn: "{phone} ಗೆ ಕರೆ ಮಾಡಿ",
    whatsappBtn: "💬 WhatsApp ನಲ್ಲಿ ಚಾಟ್ ಮಾಡಿ",
    whatsappMessage: "ನಮಸ್ಕಾರ, ToLetBook ನಲ್ಲಿ ಲಿಸ್ಟ್ ಆಗಿರುವ ನಿಮ್ಮ ಪ್ರಾಪರ್ಟಿ \"{property}\" ಬಗ್ಗೆ ನನಗೆ ಆಸಕ್ತಿ ಇದೆ. ಇದು ಇನ್ನೂ ಲಭ್ಯವಿದೆಯೇ?",
    contactUnlockedToast: "ಕಾಂಟ್ಯಾಕ್ಟ್ ನಂಬರ್ ಅನ್‌ಲಾಕ್ ಆಗಿದೆ",
    couldNotUnlockToast: "ಕಾಂಟ್ಯಾಕ್ಟ್ ಅನ್‌ಲಾಕ್ ಮಾಡಲು ಆಗಲಿಲ್ಲ",
  },
  tenantPayments: {
    noActiveTenancy: "ಬಾಡಿಗೆ ಪಾವತಿಸಲು ನಿಮಗೆ ಯಾವುದೇ ಆಕ್ಟಿವ್ ಟೆನೆನ್ಸಿ ಇಲ್ಲ.",
    title: "ಪೇಮೆಂಟ್ಸ್",
    paidStatus: "ಪಾವತಿಯಾಗಿದೆ",
    rentDue: "ಬಾಡಿಗೆ ಬಾಕಿ ಇದೆ",
    reminderBanner: "🔔 ಈ ಪಾವತಿಯ ಬಗ್ಗೆ ನಿಮ್ಮ ಓನರ್ ರಿಮೈಂಡರ್ ಕಳುಹಿಸಿದ್ದಾರೆ",
    payingBtn: "ಪಾವತಿಸಲಾಗುತ್ತಿದೆ…",
    payViaUpi: "UPI ಮೂಲಕ {amount} ಪಾವತಿಸಿ",
    payNow: "{amount} ಪಾವತಿಸಿ",
    paymentFailedToast: "ಪಾವತಿ ಆಗಲಿಲ್ಲ — ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
    paymentRecordedToast: "ಪಾವತಿ ದಾಖಲಾಗಿದೆ",
    viewReceiptBtn: "ರಸೀದಿ ನೋಡಿ",
    history: "ಇತಿಹಾಸ",
    payViaUpiDirectlyBtn: "ನೇರವಾಗಿ UPI ಮೂಲಕ ಪಾವತಿಸಿ",
    ownerUpiIdLabel: "ಓನರ್ UPI ID",
    copyUpiBtn: "ಕಾಪಿ ಮಾಡಿ",
    upiIdCopiedToast: "UPI ID ಕಾಪಿ ಆಗಿದೆ",
    openUpiAppBtn: "UPI ಆ್ಯಪ್ ತೆರೆಯಿರಿ",
    markPaidUpiBtn: "ನಾನು UPI ಮೂಲಕ ಪಾವತಿಸಿದ್ದೇನೆ",
    markPaidUpiConfirm: "ಈ ಬಾಡಿಗೆಯನ್ನು ಓನರ್‌ನ UPI ID ಗೆ ಕಳುಹಿಸಿದ್ದೀರಾ? ಇದು ಪಾವತಿಸಲಾಗಿದೆ ಎಂದು ಗುರುತಿಸುತ್ತದೆ.",
  },
  tenantRequests: {
    title: "ಮೈಂಟೆನೆನ್ಸ್ ರಿಕ್ವೆಸ್ಟ್‌ಗಳು",
    cancelLink: "ರದ್ದುಮಾಡಿ ›",
    newLink: "+ ಹೊಸದು ›",
    whatsWrong: "ಏನು ಸಮಸ್ಯೆ?",
    issuePlaceholder: "ಉದಾ. ನಲ್ಲಿಯಿಂದ ನೀರು ಸೋರಿಕೆ",
    detailsOptional: "ವಿವರಗಳು (ಐಚ್ಛಿಕ)",
    submittingBtn: "ಸಬ್ಮಿಟ್ ಆಗುತ್ತಿದೆ…",
    submitRequestBtn: "ರಿಕ್ವೆಸ್ಟ್ ಸಬ್ಮಿಟ್ ಮಾಡಿ",
    giveTitleError: "ರಿಕ್ವೆಸ್ಟ್‌ಗೆ ಒಂದು ಟೈಟಲ್ ಕೊಡಿ",
    requestRaisedToast: "ರಿಕ್ವೆಸ್ಟ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    noRequestsYet: "ಇನ್ನೂ ಯಾವುದೇ ರಿಕ್ವೆಸ್ಟ್ ಮಾಡಿಲ್ಲ.",
    noDetailsProvided: "ಯಾವುದೇ ವಿವರಗಳನ್ನು ನೀಡಿಲ್ಲ",
    myVisitsHeading: "ನನ್ನ ವಿಸಿಟ್ ರಿಕ್ವೆಸ್ಟ್‌ಗಳು",
    emptyNoVisits: "ನೀವು ಇನ್ನೂ ಯಾವುದೇ ಪ್ರಾಪರ್ಟಿ ವಿಸಿಟ್ ರಿಕ್ವೆಸ್ಟ್ ಮಾಡಿಲ್ಲ.",
    visitLine: "{date} ರಂದು {time}ಗೆ",
    cancelVisitButton: "ರದ್ದುಮಾಡಿ",
    visitCancelledToast: "ವಿಸಿಟ್ ರಿಕ್ವೆಸ್ಟ್ ರದ್ದುಮಾಡಲಾಗಿದೆ",
    visitStatusPending: "ಬಾಕಿ ಇದೆ",
    visitStatusConfirmed: "ಖಚಿತಪಡಿಸಲಾಗಿದೆ",
    visitStatusDeclined: "ತಿರಸ್ಕರಿಸಲಾಗಿದೆ",
    visitStatusCancelled: "ರದ್ದುಮಾಡಲಾಗಿದೆ",
    vacateNoticeHeading: "ಖಾಲಿ ಮಾಡುವ ನೋಟಿಸ್",
    giveNoticeLink: "+ ನೋಟಿಸ್ ನೀಡಿ ›",
    vacateOnLabel: "{date} ರಂದು ಖಾಲಿ ಮಾಡುತ್ತಾರೆ",
    noticeGivenOnLabel: "{date} ರಂದು ನೋಟಿಸ್ ನೀಡಲಾಗಿದೆ",
    vacateStatusPending: "ಬಾಕಿ ಇದೆ",
    vacateStatusAcknowledged: "ಒಪ್ಪಿಕೊಳ್ಳಲಾಗಿದೆ",
    vacateStatusCancelled: "ರದ್ದುಮಾಡಲಾಗಿದೆ",
    shareWhatsappBtn: "💬 WhatsApp ನಲ್ಲಿ ಶೇರ್ ಮಾಡಿ",
    cancelNoticeBtn: "ನೋಟಿಸ್ ರದ್ದುಮಾಡಿ",
    noticeDateLabel: "ನೋಟಿಸ್ ದಿನಾಂಕ",
    vacateDatePreview: "ನಿಮ್ಮ {days}-ದಿನಗಳ ನೋಟಿಸ್ ಅವಧಿಯ ಪ್ರಕಾರ, ನೀವು {date} ರಂದು ಖಾಲಿ ಮಾಡುತ್ತೀರಿ",
    submitVacateNoticeBtn: "ಖಾಲಿ ಮಾಡುವ ನೋಟಿಸ್ ಸಲ್ಲಿಸಿ",
    vacateNoticeSentToast: "ಖಾಲಿ ಮಾಡುವ ನೋಟಿಸ್ ಓನರ್‌ಗೆ ಕಳುಹಿಸಲಾಗಿದೆ",
    vacateNoticeCancelledToast: "ಖಾಲಿ ಮಾಡುವ ನೋಟಿಸ್ ರದ್ದುಮಾಡಲಾಗಿದೆ",
    emptyNoVacateNotices: "ನೀವು ಇನ್ನೂ ಯಾವುದೇ ಖಾಲಿ ಮಾಡುವ ನೋಟಿಸ್ ನೀಡಿಲ್ಲ.",
    vacateWhatsappMessage: "ನಮಸ್ಕಾರ {owner}, ನಾನು \"{property}\" ಖಾಲಿ ಮಾಡುತ್ತಿದ್ದೇನೆ ಎಂದು ಔಪಚಾರಿಕವಾಗಿ ತಿಳಿಸಲು ಇದು. ನೋಟಿಸ್ {noticeDate} ರಂದು ನೀಡಲಾಗಿದೆ, {vacateDate} ರಂದು ಖಾಲಿ ಮಾಡುತ್ತೇನೆ.",
  },
  tenantOnboarding: {
    title: "ನಿಮ್ಮ ಮೂವ್-ಇನ್ ಪೂರ್ಣಗೊಳಿಸಿ",
    nameLabel: "ನಿಮ್ಮ ಹೆಸರು (ಆಧಾರ್ ಪ್ರಕಾರ)",
    nameHint: "ಈ ನಿಖರವಾದ ಹೆಸರನ್ನು ನಿಮ್ಮ ರೆಂಟಲ್ ಅಗ್ರಿಮೆಂಟ್‌ನಲ್ಲಿ ಬಳಸಲಾಗುತ್ತದೆ.",
    rentLabel: "ಮಾಸಿಕ ಬಾಡಿಗೆ",
    dueDayLabel: "ಬಾಡಿಗೆ ಪಾವತಿ ದಿನ",
    dueDayValue: "ಪ್ರತಿ ತಿಂಗಳ {day}ನೇ ದಿನಾಂಕ",
    depositLabel: "ಸೆಕ್ಯುರಿಟಿ ಡೆಪಾಸಿಟ್",
    depositPaidBadge: "ಪಾವತಿಯಾಗಿದೆ",
    depositPendingBadge: "ಬಾಕಿ",
    depositConfirmingBadge: "ದೃಢೀಕರಿಸಲಾಗುತ್ತಿದೆ…",
    payNowBtn: "ಈಗ ಪಾವತಿಸಿ",
    payingBtn: "ಪಾವತಿ ತೆರೆಯುತ್ತಿದೆ…",
    depositPaymentDesc: "ಸೆಕ್ಯುರಿಟಿ ಡೆಪಾಸಿಟ್",
    depositPaidToast: "ಡೆಪಾಸಿಟ್ ಪಾವತಿ ಸ್ವೀಕರಿಸಲಾಗಿದೆ",
    depositFailedToast: "ಪಾವತಿ ಆಗಲಿಲ್ಲ — ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
    depositPaidCashBadge: "ನಗದಿನಲ್ಲಿ ಪಾವತಿಸಲಾಗಿದೆ",
    paidInCashLink: "ನಾನು ನಗದಿನಲ್ಲಿ ಪಾವತಿಸಿದ್ದೇನೆ",
    cashProofHint: "ರಶೀದಿ ಅಥವಾ ಪಾವತಿ ಪುರಾವೆ ಫೋಟೋ ಸೇರಿಸಿ (ಐಚ್ಛಿಕ).",
    cashProofUploadLabel: "ಪುರಾವೆ ಸೇರಿಸಿ",
    confirmCashBtn: "ನಗದು ಪಾವತಿಯನ್ನು ಖಚಿತಪಡಿಸಿ",
    errDepositRequired: "ಮುಂದುವರಿಯುವ ಮೊದಲು ಸೆಕ್ಯುರಿಟಿ ಡಿಪಾಸಿಟ್ ಪಾವತಿಸಿ (ಆನ್‌ಲೈನ್ ಅಥವಾ ನಗದು)",
    amenitiesLabel: "ಓನರ್ ಒದಗಿಸಿದ ಸೌಲಭ್ಯಗಳು",
    identityVerificationLabel: "ಗುರುತಿನ ಪರಿಶೀಲನೆ",
    yourIdentityLabel: "ನೀವು",
    identityVerificationHint: "ನಿಮ್ಮ ಸರ್ಕಾರಿ-ಪರಿಶೀಲಿತ ಹೆಸರು ಬಾಡಿಗೆ ಒಪ್ಪಂದದಲ್ಲಿ ಕಾಣಿಸಲು DigiLocker ಮೂಲಕ ನಿಮ್ಮ ಗುರುತನ್ನು ಪರಿಶೀಲಿಸಿ.",
    confirmLabel: "ನಾನು ಮೇಲಿನ ನನ್ನ ಮೂವ್-ಇನ್ ವಿವರಗಳನ್ನು ಪರಿಶೀಲಿಸಿದ್ದೇನೆ ಮತ್ತು ಅವು ಸರಿಯಾಗಿವೆ ಎಂದು ಖಚಿತಪಡಿಸುತ್ತೇನೆ.",
    submitBtn: "ಸೆಟಪ್ ಪೂರ್ಣಗೊಳಿಸಿ",
    errNameRequired: "ನಿಮ್ಮ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    errMustConfirm: "ದಯವಿಟ್ಟು ನೀವು ವಿವರಗಳನ್ನು ಪರಿಶೀಲಿಸಿದ್ದೀರಿ ಎಂದು ಖಚಿತಪಡಿಸಿ",
    completedToast: "ಮೂವ್-ಇನ್ ವಿವರಗಳು ಖಚಿತಪಡಿಸಲಾಗಿದೆ",
  },
  moveInDetails: {
    title: "ಮೂವ್-ಇನ್ ವಿವರಗಳು",
  },
  locationCapture: {
    pinLocationLabel: "ಈ ಪ್ರಾಪರ್ಟಿಯ ಲೊಕೇಶನ್ ಪಿನ್ ಮಾಡಿ",
    panMapHint: "📌 ಸರಿಯಾದ ಸ್ಥಳದಲ್ಲಿ ಪಿನ್ ಇರಿಸಲು ನಕ್ಷೆಯನ್ನು ಸರಿಸಿ",
    expandMapAria: "ನಕ್ಷೆಯನ್ನು ವಿಸ್ತರಿಸಿ",
    clear: "ಕ್ಲಿಯರ್",
    searchPlaceholder: "ವಿಳಾಸ ಹುಡುಕಿ",
    loadingSearch: "ಸರ್ಚ್ ಲೋಡ್ ಆಗುತ್ತಿದೆ…",
    or: "ಅಥವಾ",
    locating: "ಲೊಕೇಶನ್ ಪತ್ತೆಹಚ್ಚಲಾಗುತ್ತಿದೆ…",
    useCurrentLocation: "📍 ಪ್ರಸ್ತುತ ಲೊಕೇಶನ್ ಬಳಸಿ",
    pickSuggestion: "ಡ್ರಾಪ್‌ಡೌನ್‌ನಿಂದ ಒಂದು ಸಲಹೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    locationNotSupported: "ಈ ಬ್ರೌಸರ್‌ನಲ್ಲಿ ಲೊಕೇಶನ್ ಬೆಂಬಲಿಸುವುದಿಲ್ಲ",
    locationPermissionDenied: "ಲೊಕೇಶನ್ ಅನುಮತಿ ನಿರಾಕರಿಸಲಾಗಿದೆ",
    locationCouldNotGet: "ನಿಮ್ಮ ಲೊಕೇಶನ್ ಪಡೆಯಲು ಆಗಲಿಲ್ಲ",
    hint: "ವಿಳಾಸ ಹುಡುಕಿ ಅಥವಾ ಕೆಳಗಿನ ಏರಿಯಾವನ್ನು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ತುಂಬಲು GPS ಟ್ಯಾಪ್ ಮಾಡಿ — ಡೋರ್ ನಂಬರ್ ಮತ್ತು ಬಿಲ್ಡಿಂಗ್ ಹೆಸರನ್ನು ನೀವೇ ನಮೂದಿಸಬೇಕು.",
  },
  googleMap: {
    yourLocation: "ನಿಮ್ಮ ಲೊಕೇಶನ್",
    couldNotLoad: "Google Maps ಲೋಡ್ ಆಗಲಿಲ್ಲ — API ಕೀ ಪರಿಶೀಲಿಸಿ",
    viewDetails: "ವಿವರಗಳನ್ನು ನೋಡಿ ›",
  },
  rentReceipt: {
    back: "‹ ಹಿಂದೆ",
    paymentRecordedBanner: "✓ ಪಾವತಿ ದಾಖಲಾಗಿದೆ — ಇಲ್ಲಿದೆ ನಿಮ್ಮ ರಸೀದಿ.",
    title: "ಬಾಡಿಗೆ ರಸೀದಿ",
    amountPaid: "ಪಾವತಿಸಿದ ಮೊತ್ತ",
    receiptNoLabel: "ರಸೀದಿ ನಂಬರ್",
    paidByLabel: "ಪಾವತಿಸಿದವರು",
    propertyLabel: "ಪ್ರಾಪರ್ಟಿ",
    receivedByLabel: "ಸ್ವೀಕರಿಸಿದವರು",
    forMonthLabel: "ಯಾವ ತಿಂಗಳಿಗೆ",
    paymentModeLabel: "ಪಾವತಿ ವಿಧಾನ",
    paidOnLabel: "ಪಾವತಿಸಿದ ದಿನಾಂಕ",
    downloadBtn: "ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    shareBtn: "ಶೇರ್ ಮಾಡಿ",
    htmlTitle: "ಬಾಡಿಗೆ ರಸೀದಿ - {month}",
    htmlStamp: "✓ ಪಾವತಿಯಾಗಿದೆ",
    htmlAmountPaidLabel: "ಪಾವತಿಸಿದ ಮೊತ್ತ",
    htmlFooter: "ಇದು ToLetBook ನಿಂದ ಸಿಸ್ಟಮ್-ಜನರೇಟೆಡ್ ರಸೀದಿ. ಇಲ್ಲಿ ತೋರಿಸಿರುವ ಬಾಡಿಗೆಯನ್ನು ಆ್ಯಪ್‌ನಲ್ಲಿ ದಾಖಲಿಸಲಾಗಿದೆ, ಇದನ್ನು ನಿಜವಾದ ಪೇಮೆಂಟ್ ಗೇಟ್‌ವೇ ಮೂಲಕ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಿಲ್ಲ.",
    shareTitle: "ಬಾಡಿಗೆ ರಸೀದಿ - {month}",
    shareText: "ರಸೀದಿ {receiptNo}, ಮೊತ್ತ {amount}",
  },
  rentalAgreement: {
    back: "‹ ಹಿಂದೆ",
    title: "ರೆಂಟಲ್ ಅಗ್ರಿಮೆಂಟ್",
    ownerLabel: "ಓನರ್",
    tenantLabel: "ಟೆನೆಂಟ್",
    propertyLabel: "ಪ್ರಾಪರ್ಟಿ",
    typeLabel: "ಟೈಪ್",
    monthlyRentLabel: "ಮಾಸಿಕ ಬಾಡಿಗೆ",
    securityDepositLabel: "ಸೆಕ್ಯುರಿಟಿ ಡೆಪಾಸಿಟ್",
    moveInDateLabel: "ಮೂವ್-ಇನ್ ದಿನಾಂಕ",
    disclaimer: "ಇದು ರೆಕಾರ್ಡ್‌ನಲ್ಲಿರುವ ಟೆನೆನ್ಸಿ ವಿವರಗಳಿಂದ ಸ್ವಯಂಚಾಲಿತವಾಗಿ ರಚಿಸಲಾದ ಸಾರಾಂಶ, ಇದು ಕಾನೂನುಬದ್ಧವಾಗಿ ಬಂಧಕವಾದ ದಾಖಲೆಯಲ್ಲ. ಸಾಮಾನ್ಯ ಡೆಮೊ ನಿಯಮಗಳು: ಪ್ರತಿ ತಿಂಗಳ 5ನೇ ತಾರೀಖಿನೊಳಗೆ ಬಾಡಿಗೆ ಪಾವತಿಸಬೇಕು, ಟೆನೆನ್ಸಿ ಮುಗಿಸಲು 30 ದಿನಗಳ ಸೂಚನೆ, ಸಾಮಾನ್ಯ ಸವೆತಕ್ಕಿಂತ ಹೆಚ್ಚಿನ ಹಾನಿಗೆ ಕಡಿತ ಮಾಡಿ ಡೆಪಾಸಿಟ್ ಹಿಂತಿರುಗಿಸಲಾಗುತ್ತದೆ.",
    downloadAgreementBtn: "ಅಗ್ರಿಮೆಂಟ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    stampStatusLabel: "E-Stamp ಸ್ಥಿತಿ",
    stampStatusNotStarted: "ಪ್ರಾರಂಭವಾಗಿಲ್ಲ",
    stampStatusProcessing: "ಪ್ರೊಸೆಸ್ ಆಗುತ್ತಿದೆ",
    stampStatusVerified: "ವೆರಿಫೈ ಆಗಿದೆ",
    stampHint: "ಈ ಅಗ್ರಿಮೆಂಟ್ ಅನ್ನು ಸರ್ಕಾರದಿಂದ ಕಾನೂನುಬದ್ಧವಾಗಿ E-Stamp ಮಾಡಿಸಿ. ಇದಕ್ಕೆ {amount} ನಿಜವಾದ ಸರ್ಕಾರಿ ಶುಲ್ಕ ಅನ್ವಯಿಸುತ್ತದೆ.",
    stampFeeAlreadyPaidHint: "ನಿಮ್ಮ E-Stamp ಶುಲ್ಕ ಪಾವತಿಯಾಗಿದೆ — ಆರ್ಡರ್ ಅನ್ನು ಮಾತ್ರ ಇನ್ನೂ ಇಡಲಾಗಿಲ್ಲ. ಯಾವುದೇ ಹೆಚ್ಚುವರಿ ಶುಲ್ಕವಿಲ್ಲದೆ ಕೆಳಗೆ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    sendForStampBtn: "{amount} ಪಾವತಿಸಿ E-Stamp ಗಾಗಿ ಕಳುಹಿಸಿ",
    retrySendForStampBtn: "E-Stamp ಗಾಗಿ ಮತ್ತೆ ಕಳುಹಿಸಿ",
    sendingStampBtn: "ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ…",
    confirmingPaymentBtn: "ಪಾವತಿಯನ್ನು ದೃಢೀಕರಿಸಲಾಗುತ್ತಿದೆ…",
    stampFeePaymentDesc: "ಸರ್ಕಾರಿ E-Stamp ಶುಲ್ಕ",
    stampFeeFailedToast: "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ — ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
    stampSentToast: "ಸರ್ಕಾರಿ E-Stamping ಗಾಗಿ ಕಳುಹಿಸಲಾಗಿದೆ",
    refreshStatusBtn: "ಸ್ಥಿತಿ ರಿಫ್ರೆಶ್ ಮಾಡಿ",
    viewStampedBtn: "ಸ್ಟಾಂಪ್ ಮಾಡಿದ ಅಗ್ರಿಮೆಂಟ್ ನೋಡಿ",
    identityVerificationLabel: "ಗುರುತಿನ ಪರಿಶೀಲನೆ",
    digilockerVerifiedBadge: "ಪರಿಶೀಲಿಸಲಾಗಿದೆ",
    digilockerNotVerifiedBadge: "ಪರಿಶೀಲಿಸಲಾಗಿಲ್ಲ",
    verifyDigilockerBtn: "DigiLocker ಮೂಲಕ ಪರಿಶೀಲಿಸಿ",
    verifyingDigilockerBtn: "DigiLocker ತೆರೆಯುತ್ತಿದೆ…",
    digilockerVerifiedToast: "{name} ಎಂದು ಪರಿಶೀಲಿಸಲಾಗಿದೆ",
    digilockerDeniedToast: "DigiLocker ಪರಿಶೀಲನೆ ರದ್ದುಗೊಳಿಸಲಾಗಿದೆ",
    digilockerExpiredToast: "ಆ DigiLocker ಲಿಂಕ್ ಅವಧಿ ಮುಗಿದಿದೆ — ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
    comingSoonTitle: "ಸರ್ಕಾರಿ ಇ-ಸ್ಟಾಂಪಿಂಗ್ ಶೀಘ್ರದಲ್ಲೇ ಬರುತ್ತಿದೆ",
    comingSoonBody: "ನೀವು ಆ್ಯಪ್‌ನಿಂದಲೇ ಸಂಪೂರ್ಣ ಸರ್ಕಾರ-ಪರಿಶೀಲಿತ, ಇ-ಸ್ಟಾಂಪ್ಡ್ ಬಾಡಿಗೆ ಒಪ್ಪಂದವನ್ನು ರಚಿಸುವಂತೆ ನಾವು ಸ್ಟಾಂಪ್ ಡ್ಯೂಟಿ ಪಾವತಿಗಳನ್ನು ಸಿದ್ಧಪಡಿಸುತ್ತಿದ್ದೇವೆ.",
    interestBtn: "ನನಗೆ ಆಸಕ್ತಿ ಇದೆ — ತಿಳಿಸಿ",
    interestRegisteredBtn: "ನೀವು ಪಟ್ಟಿಯಲ್ಲಿದ್ದೀರಿ ✓",
    interestToast: "ಧನ್ಯವಾದಗಳು! ಇ-ಸ್ಟಾಂಪಿಂಗ್ ಲೈವ್ ಆದಾಗ ನಾವು ನಿಮಗೆ ತಿಳಿಸುತ್ತೇವೆ.",
    uploadDocHeading: "ಈಗಾಗಲೇ ಬಾಡಿಗೆ ಒಪ್ಪಂದ ಇದೆಯೇ?",
    uploadDocHint: "ನೀವು ToLetBook ಹೊರಗೆ ಈಗಾಗಲೇ ಒಂದನ್ನು ಮಾಡಿದ್ದರೆ, ಈ ಬಾಡಿಗೆದಾರಿಕೆಯೊಂದಿಗೆ ಉಳಿಸಲು ಇಲ್ಲಿ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ.",
    uploadDocBtn: "ಬಾಡಿಗೆ ಒಪ್ಪಂದ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    viewUploadedDocBtn: "ಅಪ್‌ಲೋಡ್ ಮಾಡಿದ ಒಪ್ಪಂದ ನೋಡಿ",
    removeUploadedDocBtn: "ತೆಗೆದುಹಾಕಿ",
    uploadedOnLabel: "{date} ರಂದು ಅಪ್‌ಲೋಡ್ ಮಾಡಲಾಗಿದೆ",
    noUploadedDocTenantHint: "ನಿಮ್ಮ ಮಾಲೀಕರು ಇನ್ನೂ ಬಾಡಿಗೆ ಒಪ್ಪಂದವನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿಲ್ಲ.",
    uploadDocSuccessToast: "ಬಾಡಿಗೆ ಒಪ್ಪಂದ ಅಪ್‌ಲೋಡ್ ಆಗಿದೆ",
    uploadDocFailedToast: "ಅಪ್‌ಲೋಡ್ ಮಾಡಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ — 8MB ಗಿಂತ ಕಡಿಮೆಯ PDF ಅಥವಾ ಚಿತ್ರವನ್ನು ಪ್ರಯತ್ನಿಸಿ",
    removeDocConfirm: "ಅಪ್‌ಲೋಡ್ ಮಾಡಿದ ಬಾಡಿಗೆ ಒಪ್ಪಂದವನ್ನು ತೆಗೆದುಹಾಕುವುದೇ?",
    removeDocSuccessToast: "ಬಾಡಿಗೆ ಒಪ್ಪಂದ ತೆಗೆದುಹಾಕಲಾಗಿದೆ",
    htmlTitle: "ರೆಂಟಲ್ ಅಗ್ರಿಮೆಂಟ್ - {property}",
    htmlDocTitle: "ರೆಂಟಲ್ ಅಗ್ರಿಮೆಂಟ್ ಸಾರಾಂಶ",
    htmlAgreementNo: "ಅಗ್ರಿಮೆಂಟ್ ನಂಬರ್ {no}",
    htmlOwnerLessor: "ಓನರ್ / ಲೆಸರ್",
    htmlTenantLessee: "ಟೆನೆಂಟ್ / ಲೆಸಿ",
    htmlPropertyHeading: "ಪ್ರಾಪರ್ಟಿ",
    htmlAddressLabel: "ವಿಳಾಸ",
    htmlTypeLabel: "ಟೈಪ್",
    htmlTermsHeading: "ನಿಯಮಗಳು",
    htmlMonthlyRentLabel: "ಮಾಸಿಕ ಬಾಡಿಗೆ",
    htmlSecurityDepositLabel: "ಸೆಕ್ಯುರಿಟಿ ಡೆಪಾಸಿಟ್",
    htmlMoveInDateLabel: "ಮೂವ್-ಇನ್ ದಿನಾಂಕ",
    htmlConditionsHeading: "ಷರತ್ತುಗಳು",
    htmlCond1: "ಬಾಡಿಗೆಯನ್ನು ಪ್ರತಿ ತಿಂಗಳ 5ನೇ ತಾರೀಖಿನೊಳಗೆ, ಒಪ್ಪಿದ ವಿಧಾನದ ಮೂಲಕ ಓನರ್‌ಗೆ ಪಾವತಿಸಬೇಕು.",
    htmlCond2: "ಸಾಮಾನ್ಯ ಸವೆತಕ್ಕಿಂತ ಹೆಚ್ಚಿನ ಹಾನಿಗಳಿಗೆ ಕಡಿತ ಮಾಡಿ, ಮೂವ್-ಔಟ್ ಸಮಯದಲ್ಲಿ ಸೆಕ್ಯುರಿಟಿ ಡೆಪಾಸಿಟ್ ಹಿಂತಿರುಗಿಸಲಾಗುತ್ತದೆ.",
    htmlCond3: "ಟೆನೆನ್ಸಿ ಮುಗಿಸುವ ಮೊದಲು ಎರಡೂ ಪಕ್ಷಗಳು ಕನಿಷ್ಠ 30 ದಿನಗಳ ಲಿಖಿತ ಸೂಚನೆ ನೀಡಬೇಕು.",
    htmlCond4: "ಓನರ್ ಜೊತೆ ಬೇರೆ ರೀತಿಯಲ್ಲಿ ಒಪ್ಪದಿದ್ದರೆ, ಯುಟಿಲಿಟಿ ಬಿಲ್‌ಗಳ ಜವಾಬ್ದಾರಿ ಟೆನೆಂಟ್‌ದೇ ಆಗಿರುತ್ತದೆ.",
    htmlCond5: "ಟೆನೆಂಟ್‌ನ ನಿರ್ಲಕ್ಷ್ಯದಿಂದ ಹಾನಿಯಾಗದ ಹೊರತು, ಫಿಕ್ಸ್ಚರ್‌ಗಳು ಮತ್ತು ಫಿಟ್ಟಿಂಗ್‌ಗಳ ಮೈಂಟೆನೆನ್ಸ್ ಜವಾಬ್ದಾರಿ ಓನರ್‌ದೇ ಆಗಿರುತ್ತದೆ.",
    htmlFooter: "ಈ ಸಾರಾಂಶವನ್ನು ರೆಕಾರ್ಡ್‌ನಲ್ಲಿರುವ ಟೆನೆನ್ಸಿ ವಿವರಗಳಿಂದ ToLetBook ಸ್ವಯಂಚಾಲಿತವಾಗಿ ರಚಿಸಿದೆ ಮತ್ತು ಇದು ಕಾನೂನುಬದ್ಧವಾಗಿ ಬಂಧಕವಾದ ದಾಖಲೆಯಲ್ಲ. ಔಪಚಾರಿಕ ರೆಂಟಲ್ ಅಗ್ರಿಮೆಂಟ್ ರಚಿಸಲು ಕಾನೂನು ತಜ್ಞರನ್ನು ಸಂಪರ್ಕಿಸಿ.",
  },
  photoLightbox: {
    closeAria: "ಮುಚ್ಚಿ",
    previousPhotoAria: "ಹಿಂದಿನ ಫೋಟೋ",
    nextPhotoAria: "ಮುಂದಿನ ಫೋಟೋ",
    countLabel: "{current} / {total}",
  },
  tenantPlan: {
    title: "ಪ್ಲಾನ್",
    currentPlanLabel: "ಪ್ರಸ್ತುತ ಪ್ಲಾನ್",
    basicName: "ಬೇಸಿಕ್",
    proName: "ಟೆನೆಂಟ್ ಪ್ರೊ",
    proSub: "ಸಕ್ರಿಯವಾಗಿ ಮನೆ ಹುಡುಕುತ್ತಿರುವ ಟೆನೆಂಟ್‌ಗಳಿಗೆ",
    priceValidity: "1 ತಿಂಗಳು ಮಾನ್ಯ",
    featUnlock: "30 ದಿನಗಳವರೆಗೆ ಅನಿಯಮಿತ ಓನರ್ ಕಾಂಟ್ಯಾಕ್ಟ್ ನಂಬರ್‌ಗಳನ್ನು ಅನ್‌ಲಾಕ್ ಮಾಡಿ",
    featNearby: "ಪ್ರತಿ ಲಿಸ್ಟಿಂಗ್‌ನಲ್ಲಿ ಪೂರ್ಣ ಮ್ಯಾಪ್ ಮತ್ತು ಹತ್ತಿರದ-ಸ್ಥಳಗಳ ಆಕ್ಸೆಸ್",
    featWhatsapp: "ಓನರ್‌ಗೆ ನೇರವಾಗಿ WhatsApp ನಲ್ಲಿ ಮಾತನಾಡಿ, ಪ್ರತಿ-ಲಿಸ್ಟಿಂಗ್ ಶುಲ್ಕ ಇಲ್ಲ",
    featFallback: "ಸಬ್‌ಸ್ಕ್ರೈಬ್ ಮಾಡದಿದ್ದರೂ 1 ಓನರ್ ಕಾಂಟ್ಯಾಕ್ಟ್ ಉಚಿತವಾಗಿ ಅನ್‌ಲಾಕ್ ಆಗುತ್ತದೆ — ಆಮೇಲೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಬೇಕಾಗುತ್ತದೆ",
    currentPlanBtn: "ಪ್ರಸ್ತುತ ಪ್ಲಾನ್",
    subscribeBtn: "₹99 ಕ್ಕೆ ಸಬ್‌ಸ್ಕ್ರೈಬ್ ಮಾಡಿ",
    activeUntil: "{date} ವರೆಗೆ ಆಕ್ಟಿವ್",
    noChargeNote: "ಇನ್ನೂ ಪಾವತಿ ಅಗತ್ಯವಿಲ್ಲ — ಬಿಲ್ಲಿಂಗ್ ಸೆಟಪ್ ಆಗುವವರೆಗೆ ಸಬ್‌ಸ್ಕ್ರೈಬ್ ಮಾಡುವುದು ಉಚಿತ.",
    subscribedToast: "ಟೆನೆಂಟ್ ಪ್ರೊ ಆಕ್ಟಿವೇಟ್ ಆಗಿದೆ",
    switchFailedToast: "ನಿಮ್ಮ ಪ್ಲಾನ್ ಅಪ್‌ಡೇಟ್ ಮಾಡಲು ಆಗಲಿಲ್ಲ",
    nearbyUpsellTitle: "ಮ್ಯಾಪ್ ಮತ್ತು ಹತ್ತಿರದ ಸ್ಥಳಗಳನ್ನು ಅನ್‌ಲಾಕ್ ಮಾಡಿ",
    nearbyUpsellBody: "ಪ್ರತಿ ಲಿಸ್ಟಿಂಗ್ ಹತ್ತಿರ ಟ್ರಾನ್ಸಿಟ್, ಅಗತ್ಯ ವಸ್ತುಗಳು ಮತ್ತು ಆರೋಗ್ಯ ಸೇವೆಯನ್ನು ನೋಡಲು ಟೆನೆಂಟ್ ಪ್ರೊಗೆ ಸಬ್‌ಸ್ಕ್ರೈಬ್ ಮಾಡಿ.",
    nearbyUpsellBtn: "ಟೆನೆಂಟ್ ಪ್ರೊ ನೋಡಿ",
    cancelPlanBtn: "ಪ್ಲಾನ್ ರದ್ದುಗೊಳಿಸಿ",
    securePaymentNote: "ಪಾವತಿಗಳನ್ನು Razorpay ಮೂಲಕ ಸುರಕ್ಷಿತವಾಗಿ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತದೆ.",
    cancelledToast: "ಟೆನೆಂಟ್ ಪ್ರೊ ರದ್ದುಗೊಳಿಸಲಾಗಿದೆ",
  },
};
